/* This file was auto-generated with the command "generate-graphql-types" */
import * as Types from '~/graphql/generated/types';

import * as Operations from './queries';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TopicSortOrderQueryVariables = Types.Exact<{
    orderBy?: Types.InputMaybe<
        Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
    >;
}>;

export type TopicSortOrderQuery = { topicDocuments: { data: Array<{ id: Types.UUID }> } };

export type CurrentUserSpecialityQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CurrentUserSpecialityQuery = {
    topicDocuments: { data: Array<{ id: Types.UUID; code: string }> };
};

export type TopicsForSelectorQueryVariables = Types.Exact<{ [key: string]: never }>;

export type TopicsForSelectorQuery = {
    topicDocuments: {
        data: Array<{
            id: Types.UUID;
            code: string;
            description?: Types.JSON | null;
            iconPrimaryColor: string;
            abbreviation?: Types.JSON | null;
            specialityIconUrl?: string | null;
        }>;
    };
};

export type AllGuidelinesForGuidelinesPageQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type AllGuidelinesForGuidelinesPageQuery = {
    contentDocuments: {
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            startDateTime?: string | null;
            bookmarked?: boolean | null;
            title?: string | null;
            topics: Array<{ id: Types.UUID; code: string; level?: number | null }>;
            source?: { url?: string | null } | null;
        }>;
    };
};

export type SearchForTopicsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type SearchForTopicsQuery = {
    topicDocuments: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            id: Types.UUID;
            code: string;
            level?: number | null;
            subtopicPriority?: number | null;
            abbreviation?: Types.JSON | null;
            description?: Types.JSON | null;
            specialityIconUrl?: string | null;
            iconPrimaryColor: string;
            parents: Array<{ code: string }>;
        }>;
        aggregations?: Array<{
            name: string;
            buckets?: Array<{ key?: string | null; value?: string | null } | null> | null;
        } | null> | null;
    };
};

export type ContentDocumentsSimplifiedQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type ContentDocumentsSimplifiedQuery = {
    contentDocuments: { totalCount?: number | null; data: Array<{ id: Types.UUID }> };
};

export type ContentDocumentsQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type ContentDocumentsQuery = {
    contentDocuments: {
        totalCount?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            endDateTime?: string | null;
            externalId?: string | null;
            contentId: string;
            contentType: Types.ContentType;
            startDateTime?: string | null;
            willBeBroadcasted?: boolean | null;
            isFree?: boolean | null;
            isAvailableOnHomepage?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            locale?: Locale | null;
            title?: string | null;
            city?: Types.JSON | null;
            subtitle?: string | null;
            slug?: string | null;
            specialities: Array<string>;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
            providers: Array<{ name?: string | null; id: Types.UUID }>;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            scientificLeaders: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                level?: number | null;
                subtopicPriority?: number | null;
                abbreviation?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            parent?: {
                locale?: Locale | null;
                isFree?: boolean | null;
                contentId: string;
                contentType: Types.ContentType;
            } | null;
            product?: {
                name?: Types.JSON | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                brand?: Types.ProductBrand | null;
            } | null;
        }>;
    };
};

export type ProductsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type ProductsQuery = {
    productsByContent: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            accreditation?: Types.JSON | null;
            brand?: Types.ProductBrand | null;
            code: string;
            country?: string | null;
            contentType?: Types.ContentType | null;
            description?: Types.JSON | null;
            descriptionTitle?: Types.JSON | null;
            isScientificLeaderEnabled?: boolean | null;
            id: Types.UUID;
            isEnabled?: boolean | null;
            isExternal?: boolean | null;
            liveStreamInfo?: Types.JSON | null;
            specialityIconUrl?: string | null;
            iconPrimaryColor: string;
            name?: Types.JSON | null;
            targetGroupIds: Array<Types.UUID>;
            benefitIds: Array<Types.UUID>;
            seoSettings?: {
                description?: Types.JSON | null;
                image?: string | null;
                indexSetting?: Types.SeoIndexSetting | null;
                title?: Types.JSON | null;
            } | null;
            targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
            benefits: Array<{
                id: Types.UUID;
                title?: Types.JSON | null;
                footNote?: Types.JSON | null;
                iconUrl?: string | null;
                isFootNoteEnabled?: boolean | null;
                usage?: Types.BenefitUsage | null;
            }>;
        }>;
    };
};

export type ContentsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type ContentsQuery = {
    contentsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Content';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            endDateTime?: string | null;
            contentId: string;
            contentType?: Types.ContentType | null;
            startDateTime?: string | null;
            description?: Types.JSON | null;
            descriptionTitle?: Types.JSON | null;
            isScientificLeaderEnabled?: boolean | null;
            specialities: Array<string>;
            externalId?: string | null;
            willBeBroadcasted?: boolean | null;
            isFree?: boolean | null;
            isAvailableOnHomepage?: boolean | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            participationOption?: Types.ContentParticipationOption | null;
            locale?: Locale | null;
            isAvailableWithoutEfn?: boolean | null;
            validDate?: string | null;
            isOnDemand?: boolean | null;
            isOnSite?: boolean | null;
            willBeOnDemand?: boolean | null;
            subtitle?: string | null;
            title?: string | null;
            city?: Types.JSON | null;
            partnershipIds: Array<Types.UUID>;
            sponsorshipIds: Array<Types.UUID>;
            publishedCountries: Array<string>;
            targetGroupIds: Array<Types.UUID>;
            slug?: string | null;
            isCommercial?: boolean | null;
            benefitIds: Array<Types.UUID>;
            attachmentIds: Array<Types.UUID>;
            topicIds: Array<Types.UUID>;
            keywords: Array<string>;
            replacementDate?: string | null;
            replacementTitle?: string | null;
            provider?: {
                id: Types.UUID;
                name?: string | null;
                country?: string | null;
                logoUrl?: string | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
            detailsPageSettings?: {
                eventBookable?: boolean | null;
                redirectThroughExhibition?: boolean | null;
            } | null;
            attachments: Array<{
                attachmentType?: Types.AttachmentType | null;
                contentId: Types.UUID;
                fileId?: Types.UUID | null;
                groupId?: string | null;
                id: Types.UUID;
                file?: {
                    downloadUrl?: string | null;
                    id: Types.UUID;
                    mimetype?: string | null;
                    name?: string | null;
                    shortUrl?: string | null;
                    size?: number | null;
                    uploadUrl?: string | null;
                    url?: string | null;
                    permissions: Array<{
                        id?: Types.UUID | null;
                        permissionType?: Types.PermissionType | null;
                        scope?: Types.JSON | null;
                    } | null>;
                } | null;
            }>;
            sponsorships: Array<{
                __typename: 'Sponsorship';
                contentId: Types.UUID;
                description?: Types.JSON | null;
                id: Types.UUID;
                sponsorCompanyId?: Types.UUID | null;
                sponsorshipAmount?: number | null;
                sponsorshipType?: Types.SponsorshipType | null;
                virtualExhibition?: boolean | null;
                symposiumIds: Array<Types.UUID | null>;
                entireEventSponsor?: boolean | null;
                participantRestriction: boolean;
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                    websites?: Types.JSON | null;
                    country?: string | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
                sponsorDepartments?: Array<{
                    logoUrl?: string | null;
                    id: Types.UUID;
                    companyPage?: {
                        id: Types.UUID;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null> | null;
                symposiums: Array<{
                    id: Types.UUID;
                    title?: string | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    externalId?: string | null;
                    sponsorships: Array<{
                        sponsorshipAmount?: number | null;
                        sponsorCompany?: { logoUrl?: string | null; name?: string | null } | null;
                    }>;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null>;
                content?: {
                    __typename: 'Content';
                    id: Types.UUID;
                    bookmarked?: boolean | null;
                    brand?: Types.ProductBrand | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    contentId: string;
                    contentType?: Types.ContentType | null;
                    locale?: Locale | null;
                    title?: string | null;
                    city?: Types.JSON | null;
                    headerUrl?: string | null;
                    willBeBroadcasted?: boolean | null;
                    rating?: number | null;
                    externalId?: string | null;
                    product?: {
                        name?: Types.JSON | null;
                        description?: Types.JSON | null;
                        specialityIconUrl?: string | null;
                        code: string;
                        id: Types.UUID;
                        country?: string | null;
                        isScientificLeaderEnabled?: boolean | null;
                        descriptionTitle?: Types.JSON | null;
                        targetGroupIds: Array<Types.UUID>;
                        benefitIds: Array<Types.UUID>;
                        iconPrimaryColor: string;
                    } | null;
                    source?: {
                        thumbnail?: string | null;
                        duration?: number | null;
                        url?: string | null;
                        file?: {
                            downloadUrl?: string | null;
                            name?: string | null;
                            thumbnailUrl?: string | null;
                        } | null;
                    } | null;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null;
            }>;
            accreditationSettings?: {
                description?: Types.JSON | null;
                showScheme?: boolean | null;
                showSection?: boolean | null;
            } | null;
            agendaSettings?: {
                defaultDescription?: Types.JSON | null;
                showAgenda?: boolean | null;
                showProgramOverview?: boolean | null;
                showSpeakers?: boolean | null;
            } | null;
            seoSettings?: {
                description?: Types.JSON | null;
                image?: string | null;
                indexSetting?: Types.SeoIndexSetting | null;
                title?: Types.JSON | null;
            } | null;
            product?: {
                name?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                isScientificLeaderEnabled?: boolean | null;
                descriptionTitle?: Types.JSON | null;
                targetGroupIds: Array<Types.UUID>;
                benefitIds: Array<Types.UUID>;
                iconPrimaryColor: string;
                benefits: Array<{
                    id: Types.UUID;
                    title?: Types.JSON | null;
                    footNote?: Types.JSON | null;
                    iconUrl?: string | null;
                    isFootNoteEnabled?: boolean | null;
                    usage?: Types.BenefitUsage | null;
                }>;
            } | null;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            scientificLeaders: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                level?: number | null;
                subtopicPriority?: number | null;
                abbreviation?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
        }>;
    };
};

export type VerifyContentExistsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type VerifyContentExistsQuery = {
    contentsV2: {
        data: Array<{
            id: Types.UUID;
            schedule: Array<{ id: Types.UUID; source?: { url?: string | null } | null }>;
        }>;
    };
};

export type PartnerDocumentsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type PartnerDocumentsQuery = {
    contentsV2: {
        pageNumber?: number | null;
        pageSize?: number | null;
        totalCount?: number | null;
        data: Array<{
            __typename: 'Content';
            id: Types.UUID;
            bookmarked?: boolean | null;
            title?: string | null;
            isCommercial?: boolean | null;
            isAvailableWithoutEfn?: boolean | null;
            contentType?: Types.ContentType | null;
            isDownloadable?: boolean | null;
            contentId: string;
            isFree?: boolean | null;
            sponsorships: Array<{
                sponsorDepartments?: Array<{
                    companyPage?: {
                        id: Types.UUID;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null> | null;
            }>;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
        }>;
    };
};

export type SponsorshipsV2QueryVariables = Types.Exact<{
    searchQuery?: Types.InputMaybe<Types.SearchQuery>;
}>;

export type SponsorshipsV2Query = {
    sponsorshipsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Sponsorship';
            contentId: Types.UUID;
            description?: Types.JSON | null;
            id: Types.UUID;
            sponsorCompanyId?: Types.UUID | null;
            sponsorshipAmount?: number | null;
            sponsorshipType?: Types.SponsorshipType | null;
            virtualExhibition?: boolean | null;
            symposiumIds: Array<Types.UUID | null>;
            entireEventSponsor?: boolean | null;
            participantRestriction: boolean;
            sponsorCompany?: {
                id: Types.UUID;
                name?: string | null;
                logoUrl?: string | null;
                websites?: Types.JSON | null;
                country?: string | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null;
            sponsorDepartments?: Array<{
                logoUrl?: string | null;
                id: Types.UUID;
                companyPage?: {
                    id: Types.UUID;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null> | null;
            symposiums: Array<{
                id: Types.UUID;
                title?: string | null;
                startDateTime?: string | null;
                endDateTime?: string | null;
                externalId?: string | null;
                sponsorships: Array<{
                    sponsorshipAmount?: number | null;
                    sponsorCompany?: { logoUrl?: string | null; name?: string | null } | null;
                }>;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
            } | null>;
            content?: {
                __typename: 'Content';
                id: Types.UUID;
                bookmarked?: boolean | null;
                brand?: Types.ProductBrand | null;
                startDateTime?: string | null;
                endDateTime?: string | null;
                contentId: string;
                contentType?: Types.ContentType | null;
                locale?: Locale | null;
                title?: string | null;
                city?: Types.JSON | null;
                headerUrl?: string | null;
                willBeBroadcasted?: boolean | null;
                rating?: number | null;
                externalId?: string | null;
                product?: {
                    name?: Types.JSON | null;
                    description?: Types.JSON | null;
                    specialityIconUrl?: string | null;
                    code: string;
                    id: Types.UUID;
                    country?: string | null;
                    isScientificLeaderEnabled?: boolean | null;
                    descriptionTitle?: Types.JSON | null;
                    targetGroupIds: Array<Types.UUID>;
                    benefitIds: Array<Types.UUID>;
                    iconPrimaryColor: string;
                } | null;
                source?: {
                    thumbnail?: string | null;
                    duration?: number | null;
                    url?: string | null;
                    file?: {
                        downloadUrl?: string | null;
                        name?: string | null;
                        thumbnailUrl?: string | null;
                    } | null;
                } | null;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
            } | null;
        }>;
    };
};

export type SponsorshipsListQueryVariables = Types.Exact<{
    searchQuery?: Types.InputMaybe<Types.SearchQuery>;
}>;

export type SponsorshipsListQuery = {
    sponsorshipsByContent: {
        pageSize?: number | null;
        pageNumber?: number | null;
        totalCount?: number | null;
        data: Array<{
            id: Types.UUID;
            sponsorshipType?: Types.SponsorshipType | null;
            sponsorCompanyId?: Types.UUID | null;
            sponsorCompany?: {
                id: Types.UUID;
                logoUrl?: string | null;
                name?: string | null;
                websites?: Types.JSON | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null;
        }>;
    };
};

export type PartnerCompaniesQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type PartnerCompaniesQuery = {
    partnerCompanies: {
        totalCount?: number | null;
        data: Array<{
            id: Types.UUID;
            name?: string | null;
            logoUrl?: string | null;
            description?: string | null;
            slug?: string | null;
            partnerCategories: Array<{
                id: Types.UUID;
                name?: Types.JSON | null;
                order?: number | null;
            }>;
        }>;
    };
};

export type PartnerCompaniesWithDepartmentsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type PartnerCompaniesWithDepartmentsQuery = {
    partnerCompanies: {
        totalCount?: number | null;
        data: Array<{
            id: Types.UUID;
            name?: string | null;
            logoUrl?: string | null;
            description?: string | null;
            slug?: string | null;
            country?: string | null;
            publishedDomains?: Array<string | null> | null;
            departments: Array<{
                id: Types.UUID;
                translatedName?: Types.JSON | null;
                slug?: string | null;
            }>;
        }>;
    };
};

export type MediathekVideosQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type MediathekVideosQuery = {
    videos: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Video';
            id: Types.UUID;
            bookmarked?: boolean | null;
            contentId: string;
            contentType: Types.ContentType;
            specialities: Array<string>;
            title?: string | null;
            isFree?: boolean | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            rating?: number | null;
            product?: {
                name?: Types.JSON | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
            } | null;
            credits: Array<{ amount: number; unit: string }>;
            source?: { duration?: number | null; thumbnail?: string | null } | null;
            speakers: Array<{ id: Types.UUID; name: string; title?: string | null }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            parent?: {
                id: Types.UUID;
                contentId: string;
                contentType: Types.ContentType;
                isFree?: boolean | null;
            } | null;
        }>;
    };
};

export type MediathekPartnerforumContentsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type MediathekPartnerforumContentsQuery = {
    videos: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Video';
            id: Types.UUID;
            bookmarked?: boolean | null;
            contentId: string;
            contentType: Types.ContentType;
            specialities: Array<string>;
            title?: string | null;
            isFree?: boolean | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            rating?: number | null;
            product?: {
                name?: Types.JSON | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
            } | null;
            credits: Array<{ amount: number; unit: string }>;
            source?: { duration?: number | null; thumbnail?: string | null } | null;
            speakers: Array<{ id: Types.UUID; name: string; title?: string | null }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            parent?: {
                id: Types.UUID;
                contentId: string;
                contentType: Types.ContentType;
                isFree?: boolean | null;
            } | null;
            sponsorships: Array<{
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
            }>;
        }>;
    };
};

export type FeaturedCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type FeaturedCoursesQuery = {
    contentDocuments: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            title?: string | null;
            dominantColor?: string | null;
            brand?: Types.ProductBrand | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            contentId: string;
            id: Types.UUID;
            contentType: Types.ContentType;
            city?: Types.JSON | null;
            slug?: string | null;
            participationOption?: Types.ContentParticipationOption | null;
            product?: {
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                id: Types.UUID;
            } | null;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                participationType?: Types.ParticipationType | null;
            }>;
        }>;
    };
};

export type GetCompanyPageSlugQueryVariables = Types.Exact<{
    id: Types.Scalars['ID']['input'];
}>;

export type GetCompanyPageSlugQuery = {
    company: { companyPage?: { id: Types.UUID; slug?: string | null } | null };
};

export type GetCompanyDepartmentsQueryVariables = Types.Exact<{
    id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetCompanyDepartmentsQuery = {
    company: {
        departments: Array<{
            id: Types.UUID;
            companyPage?: { id: Types.UUID; slug?: string | null } | null;
        }>;
    };
};

export type GetBookingsForHistoryPageMyFomfQueryVariables = Types.Exact<{
    searchQuery: Types.BookingSearchQuery;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetBookingsForHistoryPageMyFomfQuery = {
    bookings: {
        data?: Array<{
            __typename: 'BookingR';
            id: Types.UUID;
            event?: {
                __typename: 'UserBookingEventR';
                id: Types.UUID;
                startDateTime: string;
                endDateTime: string;
                city?: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                } | null;
                country?: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                } | null;
                contentByUbEvent?: {
                    content?: {
                        __typename: 'Content';
                        id: Types.UUID;
                        brand?: Types.ProductBrand | null;
                        contentType?: Types.ContentType | null;
                        title?: string | null;
                    } | null;
                } | null;
            } | null;
            eventParticipantsSummaries?: Array<{
                __typename: 'EventParticipantsSummaryR';
                id: Types.UUID;
                eventId: Types.UUID;
                grantedPoints: Array<{ amount: number; unit: string; mainAccreditation: boolean }>;
            }> | null;
        }> | null;
    };
};

export type GetBookingsForLatestPageMyFomfQueryVariables = Types.Exact<{
    searchQuery: Types.BookingSearchQuery;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetBookingsForLatestPageMyFomfQuery = {
    bookings: {
        data?: Array<{
            __typename: 'BookingR';
            id: Types.UUID;
            event?: {
                __typename: 'UserBookingEventR';
                id: Types.UUID;
                startDateTime: string;
                endDateTime: string;
                city?: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                } | null;
                country?: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                } | null;
                contentByUbEvent?: {
                    content?: {
                        __typename: 'Content';
                        id: Types.UUID;
                        brand?: Types.ProductBrand | null;
                        contentType?: Types.ContentType | null;
                        title?: string | null;
                    } | null;
                } | null;
            } | null;
        }> | null;
    };
};

export type GetStartedSystematicCoursesForMyFomfQueryVariables = Types.Exact<{
    contentType?: Types.InputMaybe<
        | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
        | Types.InputMaybe<Types.Scalars['String']['input']>
    >;
    brandType?: Types.InputMaybe<
        | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
        | Types.InputMaybe<Types.Scalars['String']['input']>
    >;
    country?: Types.InputMaybe<
        | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
        | Types.InputMaybe<Types.Scalars['String']['input']>
    >;
    completed?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetStartedSystematicCoursesForMyFomfQuery = {
    recentlyStartedCourses?: Array<{
        course?: {
            __typename: 'Course';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            slug?: string | null;
            contentId: string;
            title?: string | null;
        } | null;
    } | null> | null;
};

export type GetOnDemandCoursesForMyFomfQueryVariables = Types.Exact<{
    contentType?: Types.InputMaybe<
        | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
        | Types.InputMaybe<Types.Scalars['String']['input']>
    >;
    brandType?: Types.InputMaybe<
        | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
        | Types.InputMaybe<Types.Scalars['String']['input']>
    >;
    country?: Types.InputMaybe<
        | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
        | Types.InputMaybe<Types.Scalars['String']['input']>
    >;
    completed?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetOnDemandCoursesForMyFomfQuery = {
    recentlyStartedCourses?: Array<{
        course?: {
            __typename: 'Course';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            contentId: string;
            title?: string | null;
            slug?: string | null;
            validDate?: string | null;
            credits: Array<{ amount: number; unit: string; isApproved?: boolean | null }>;
        } | null;
    } | null> | null;
};

export type GetStartedVideosForMyFomfQueryVariables = Types.Exact<{
    searchQuery?: Types.InputMaybe<Types.SearchQuery>;
}>;

export type GetStartedVideosForMyFomfQuery = {
    watchedVideos: {
        totalCount?: number | null;
        data: Array<{
            __typename: 'Video';
            id: Types.UUID;
            bookmarked?: boolean | null;
            contentId: string;
            title?: string | null;
            description?: Types.JSON | null;
            slug?: string | null;
            isFree?: boolean | null;
            brand?: Types.ProductBrand | null;
            rating?: number | null;
            parent?: { contentId: string; contentType: Types.ContentType } | null;
            sponsorships: Array<{
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                } | null;
            }>;
            speakers: Array<{ id: Types.UUID; name: string; title?: string | null }>;
            source?: { thumbnail?: string | null; duration?: number | null } | null;
            contentProgress?: { trackedDateTime?: string | null } | null;
        }>;
    };
};

export type GetBookmarkedGuidelinesForMyFomfQueryVariables = Types.Exact<{
    searchQuery?: Types.InputMaybe<Types.SearchQuery>;
}>;

export type GetBookmarkedGuidelinesForMyFomfQuery = {
    bookmarkedContents: {
        totalCount?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            contentId: string;
            title?: string | null;
            createdAt?: string | null;
            bookmarked?: boolean | null;
            source?: { url?: string | null } | null;
        }>;
    };
};

export type GetBookmarkedContentsForMyFomfQueryVariables = Types.Exact<{
    searchQuery?: Types.InputMaybe<Types.SearchQuery>;
}>;

export type GetBookmarkedContentsForMyFomfQuery = {
    bookmarkedContents: {
        totalCount?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            contentId: string;
            title?: string | null;
            slug?: string | null;
            startDateTime?: string | null;
            isFree?: boolean | null;
            rating?: number | null;
            bookmarked?: boolean | null;
            source?: { thumbnail?: string | null; duration?: number | null } | null;
            sponsorships: Array<{
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                } | null;
            }>;
            speakers: Array<{ id: Types.UUID; name: string; title?: string | null }>;
            parent?: { contentId: string; contentType: Types.ContentType } | null;
        }>;
    };
};

export type GetBookmarkedCoursesForMyFomfQueryVariables = Types.Exact<{
    searchQuery?: Types.InputMaybe<Types.SearchQuery>;
}>;

export type GetBookmarkedCoursesForMyFomfQuery = {
    bookmarkedContents: {
        totalCount?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            title?: string | null;
            slug?: string | null;
            contentId: string;
            contentType: Types.ContentType;
            startDateTime?: string | null;
            endDateTime?: string | null;
            validDate?: string | null;
            city?: Types.JSON | null;
            bookmarked?: boolean | null;
            credits: Array<{ amount: number; unit: string; isApproved?: boolean | null }>;
        }>;
    };
};

export type GetBookmarkedDocumentsForMyFomfQueryVariables = Types.Exact<{
    searchQuery?: Types.InputMaybe<Types.SearchQuery>;
}>;

export type GetBookmarkedDocumentsForMyFomfQuery = {
    bookmarkedContents: {
        totalCount?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            contentId: string;
            title?: string | null;
            releaseDate?: string | null;
            bookmarked?: boolean | null;
            source?: { file?: { downloadUrl?: string | null } | null } | null;
            providers: Array<{
                __typename: 'Company';
                id: Types.UUID;
                companyPage?: {
                    id: Types.UUID;
                    publishStatus?: Types.PublishStatusType | null;
                    slug?: string | null;
                } | null;
            }>;
            sponsorships: Array<{
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                } | null;
            }>;
        }>;
    };
};

export type GetUserSpecialitiesQueryVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type GetUserSpecialitiesQuery = {
    user?: { specialities: Array<{ id: string; code: string }> } | null;
};

export type GetRecommendedContentsQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type GetRecommendedContentsQuery = {
    recommendedContents: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            title?: string | null;
            brand?: Types.ProductBrand | null;
            contentId: string;
            id: Types.UUID;
            contentType: Types.ContentType;
            isFree?: boolean | null;
            rating?: number | null;
            topics: Array<{
                id: Types.UUID;
                code: string;
                iconPrimaryColor: string;
                parents: Array<{ id: Types.UUID; code: string }>;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            source?: { duration?: number | null; thumbnail?: string | null } | null;
            parent?: {
                id: Types.UUID;
                contentType: Types.ContentType;
                contentId: string;
                isFree?: boolean | null;
                providers: Array<{ id: Types.UUID; logoUrl?: string | null }>;
            } | null;
        }>;
    };
};

export type GetOnDemandContentQuestionsByIdQueryVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
}>;

export type GetOnDemandContentQuestionsByIdQuery = {
    course: {
        questions: Array<{
            id: Types.UUID;
            type: Types.QuestionType;
            description: string;
            order: number;
            module?: { id: Types.UUID } | null;
            answers?: Array<{ id: Types.UUID; description: string }> | null;
        }>;
    };
};

export type OnDemandCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type OnDemandCoursesQuery = {
    courses: {
        totalCount?: number | null;
        data: Array<{
            brand?: Types.ProductBrand | null;
            contentId: string;
            slug?: string | null;
            subtitle?: string | null;
            externalId?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            validDate?: string | null;
            city?: Types.JSON | null;
            id: Types.UUID;
            locale?: Locale | null;
            contentType: Types.ContentType;
            willBeBroadcasted?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            specialities: Array<string>;
            title?: string | null;
            product?: {
                id: Types.UUID;
                name?: Types.JSON | null;
                code: string;
                brand?: Types.ProductBrand | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                topics: Array<{ id: Types.UUID; code: string }>;
            } | null;
            modules: Array<{ id: Types.UUID }>;
            videos: Array<{
                submodule?: { id: Types.UUID; title?: Types.JSON | null } | null;
                module?: { id: Types.UUID } | null;
                source?: { duration?: number | null } | null;
            }>;
            source?: { duration?: number | null } | null;
            credits: Array<{
                participationType?: Types.ParticipationType | null;
                isApproved?: boolean | null;
                amount: number;
                unit: string;
            }>;
        }>;
        aggregations?: Array<{
            name: string;
            buckets?: Array<{ key?: string | null; value?: string | null } | null> | null;
        } | null> | null;
    };
};

export type OnDemandCourseForPlayerByIdQueryVariables = Types.Exact<{
    identifier: Types.Scalars['String']['input'];
}>;

export type OnDemandCourseForPlayerByIdQuery = {
    course: {
        __typename: 'Course';
        contentId: string;
        id: Types.UUID;
        slug?: string | null;
        subtitle?: string | null;
        description?: Types.JSON | null;
        title?: string | null;
        city?: Types.JSON | null;
        isFree?: boolean | null;
        externalId?: string | null;
        participationOption?: Types.ContentParticipationOption | null;
        courseRatingUrl?: string | null;
        videoRatingUrl?: string | null;
        brand?: Types.ProductBrand | null;
        startDateTime?: string | null;
        isAvailableOnMediathek?: boolean | null;
        endDateTime?: string | null;
        locale?: Locale | null;
        isSponsored?: boolean | null;
        contentType: Types.ContentType;
        validDate?: string | null;
        headerUrl?: string | null;
        submodules?: Array<{
            id: Types.UUID;
            title?: Types.JSON | null;
            order?: number | null;
            iconUrl?: string | null;
        }> | null;
        questions: Array<{
            id: Types.UUID;
            type: Types.QuestionType;
            description: string;
            order: number;
            module?: { id: Types.UUID } | null;
            answers?: Array<{ id: Types.UUID; description: string }> | null;
            passed?: { passedAt?: string | null; questionId: Types.UUID } | null;
        }>;
        certificate?: {
            reportDate?: string | null;
            reportStatus: Types.ReportStatus;
            file?: {
                id: Types.UUID;
                downloadUrl?: string | null;
                url?: string | null;
                name?: string | null;
            } | null;
        } | null;
        parent?: {
            contentId: string;
            contentType: Types.ContentType;
            isFree?: boolean | null;
        } | null;
        source?: {
            thumbnail?: string | null;
            duration?: number | null;
            url?: string | null;
            file?: {
                downloadUrl?: string | null;
                name?: string | null;
                thumbnailUrl?: string | null;
            } | null;
        } | null;
        providers: Array<{ name?: string | null; id: Types.UUID; logoUrl?: string | null }>;
        sponsorships: Array<{
            sponsorDepartments?: Array<{ logoUrl?: string | null } | null> | null;
            sponsorCompany?: { id: Types.UUID } | null;
        }>;
        seoSettings?: {
            title?: Types.JSON | null;
            description?: Types.JSON | null;
            image?: string | null;
            indexSetting?: Types.SeoIndexSetting | null;
        } | null;
        speakers: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        scientificLeaders: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        videos: Array<{
            order?: number | null;
            id: Types.UUID;
            bookmarked?: boolean | null;
            contentId: string;
            endDateTime?: string | null;
            title?: string | null;
            headerUrl?: string | null;
            brand?: Types.ProductBrand | null;
            isFree?: boolean | null;
            externalId?: string | null;
            isAvailableOnMediathek?: boolean | null;
            isSponsored?: boolean | null;
            contentType: Types.ContentType;
            startDateTime?: string | null;
            rating?: number | null;
            replacementDate?: string | null;
            module?: { id: Types.UUID; order?: number | null; title?: string | null } | null;
            submodule?: { id: Types.UUID } | null;
            contentProgress?: {
                trackedDateTime?: string | null;
                completed?: boolean | null;
                contentId: string;
                time?: number | null;
            } | null;
            seoSettings?: {
                image?: string | null;
                indexSetting?: Types.SeoIndexSetting | null;
            } | null;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
            providers: Array<{ name?: string | null; id: Types.UUID; logoUrl?: string | null }>;
            sponsorships: Array<{
                sponsorDepartments?: Array<{ logoUrl?: string | null } | null> | null;
                sponsorCompany?: { id: Types.UUID } | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            questions: Array<{
                id: Types.UUID;
                type: Types.QuestionType;
                description: string;
                order: number;
                answers?: Array<{ id: Types.UUID; description: string }> | null;
                passed?: { passedAt?: string | null; questionId: Types.UUID } | null;
            }>;
        }>;
        credits: Array<{
            isApproved?: boolean | null;
            participationType?: Types.ParticipationType | null;
            unit: string;
            amount: number;
        }>;
        accreditationSettings?: {
            description?: Types.JSON | null;
            showScheme?: boolean | null;
        } | null;
        agendaSettings?: {
            showAgenda?: boolean | null;
            showSpeakers?: boolean | null;
            defaultDescription?: Types.JSON | null;
        } | null;
        programSchedules: Array<{
            id: Types.UUID;
            title?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            level?: number | null;
            scheduleType?: Types.ProgramScheduleType | null;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            sponsorships: Array<{ sponsorCompany?: { name?: string | null } | null }>;
        }>;
        product?: {
            name?: Types.JSON | null;
            code: string;
            specialityIconUrl?: string | null;
        } | null;
        modules: Array<{
            id: Types.UUID;
            order?: number | null;
            title?: string | null;
            functionId?: string | null;
            credits: Array<{
                participationType?: Types.ParticipationType | null;
                isApproved?: boolean | null;
                amount: number;
                unit: string;
            }>;
            submodules?: Array<{ id: Types.UUID; order?: number | null }> | null;
            certificate?: {
                moduleId: Types.UUID;
                reportDate?: string | null;
                reportStatus: Types.ReportStatus;
                requiredCreditAmount?: number | null;
                userId: Types.UUID;
                file?: {
                    downloadUrl?: string | null;
                    id: Types.UUID;
                    name?: string | null;
                    url?: string | null;
                } | null;
            } | null;
        }>;
    };
};

export type OnDemandCourseCertificateByCourseIdQueryVariables = Types.Exact<{
    identifier: Types.Scalars['String']['input'];
}>;

export type OnDemandCourseCertificateByCourseIdQuery = {
    course: {
        __typename: 'Course';
        id: Types.UUID;
        certificate?: {
            reportDate?: string | null;
            reportStatus: Types.ReportStatus;
            file?: {
                id: Types.UUID;
                downloadUrl?: string | null;
                url?: string | null;
                name?: string | null;
            } | null;
        } | null;
    };
};

export type OnDemandCourseByIdQueryVariables = Types.Exact<{
    identifier: Types.Scalars['String']['input'];
}>;

export type OnDemandCourseByIdQuery = {
    course: {
        __typename: 'Course';
        contentId: string;
        id: Types.UUID;
        bookmarked?: boolean | null;
        slug?: string | null;
        subtitle?: string | null;
        externalId?: string | null;
        description?: Types.JSON | null;
        descriptionTitle?: Types.JSON | null;
        title?: string | null;
        courseRatingUrl?: string | null;
        videoRatingUrl?: string | null;
        city?: Types.JSON | null;
        participationOption?: Types.ContentParticipationOption | null;
        brand?: Types.ProductBrand | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        locale?: Locale | null;
        validDate?: string | null;
        contentType: Types.ContentType;
        benefits?: Array<{
            id: Types.UUID;
            title?: Types.JSON | null;
            footNote?: Types.JSON | null;
            iconUrl?: string | null;
            isFootNoteEnabled?: boolean | null;
            usage?: Types.BenefitUsage | null;
        } | null> | null;
        credits: Array<{
            amount: number;
            unit: string;
            isApproved?: boolean | null;
            accreditationInstitute?: string | null;
            participationType?: Types.ParticipationType | null;
        }>;
        certificate?: {
            reportDate?: string | null;
            reportStatus: Types.ReportStatus;
            file?: {
                id: Types.UUID;
                downloadUrl?: string | null;
                url?: string | null;
                name?: string | null;
            } | null;
        } | null;
        seoSettings?: {
            title?: Types.JSON | null;
            description?: Types.JSON | null;
            image?: string | null;
            indexSetting?: Types.SeoIndexSetting | null;
        } | null;
        scientificLeaders: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        scientificCoLeaders: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        detailsPageSettings?: {
            eventBookable?: boolean | null;
            showLocation?: boolean | null;
        } | null;
        videos: Array<{
            contentType: Types.ContentType;
            id: Types.UUID;
            title?: string | null;
            contentId: string;
            endDateTime?: string | null;
            order?: number | null;
            startDateTime?: string | null;
            replacementDate?: string | null;
            contentProgress?: {
                trackedDateTime?: string | null;
                completed?: boolean | null;
                contentId: string;
                time?: number | null;
            } | null;
            source?: {
                url?: string | null;
                duration?: number | null;
                thumbnail?: string | null;
            } | null;
            module?: { id: Types.UUID; title?: string | null } | null;
            submodule?: { id: Types.UUID; title?: Types.JSON | null; order?: number | null } | null;
            product?: { specialityIconUrl?: string | null } | null;
            questions: Array<{
                id: Types.UUID;
                type: Types.QuestionType;
                description: string;
                order: number;
                answers?: Array<{ id: Types.UUID; description: string }> | null;
                passed?: { passedAt?: string | null; questionId: Types.UUID } | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
        }>;
        accreditationSettings?: {
            description?: Types.JSON | null;
            showScheme?: boolean | null;
            showSection?: boolean | null;
        } | null;
        agendaSettings?: {
            showAgenda?: boolean | null;
            showSpeakers?: boolean | null;
            defaultDescription?: Types.JSON | null;
        } | null;
        programSchedules: Array<{
            id: Types.UUID;
            title?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            level?: number | null;
            scheduleType?: Types.ProgramScheduleType | null;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            sponsorships: Array<{ sponsorCompany?: { name?: string | null } | null }>;
        }>;
        product?: {
            name?: Types.JSON | null;
            code: string;
            specialityIconUrl?: string | null;
        } | null;
        submodules?: Array<{
            id: Types.UUID;
            title?: Types.JSON | null;
            order?: number | null;
            iconUrl?: string | null;
        }> | null;
        modules: Array<{
            id: Types.UUID;
            order?: number | null;
            title?: string | null;
            functionId?: string | null;
            submodules?: Array<{
                id: Types.UUID;
                title?: Types.JSON | null;
                iconUrl?: string | null;
                order?: number | null;
            }> | null;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                participationType?: Types.ParticipationType | null;
                accreditationInstitute?: string | null;
            }>;
            certificate?: {
                moduleId: Types.UUID;
                reportDate?: string | null;
                reportStatus: Types.ReportStatus;
                requiredCreditAmount?: number | null;
                userId: Types.UUID;
                file?: {
                    downloadUrl?: string | null;
                    id: Types.UUID;
                    name?: string | null;
                    url?: string | null;
                } | null;
            } | null;
        }>;
    };
};

export type EventPriceListQueryVariables = Types.Exact<{
    ubEventId: Types.Scalars['String']['input'];
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type EventPriceListQuery = {
    eventPriceList?: {
        earlyBirdExpirationWeeks: number;
        id: Types.UUID;
        isDefault?: boolean | null;
        name: string;
        normalPriceExpirationDays: number;
        validFrom: string;
        validUntil: string;
        currency: Types.Currency;
        taxPercentage?: number | null;
        taxType?: Types.TaxType | null;
        printedCourseBookPrice?: number | null;
        productCategory?: {
            code: string;
            id: Types.UUID;
            description: Array<{ locale: string; value: string }>;
        } | null;
        items: Array<{
            discountType: Types.DiscountType;
            earlyBirdPrice?: number | null;
            id?: Types.UUID | null;
            latePrice?: number | null;
            normalPrice: number;
            memberPrice?: number | null;
            participationType: Types.ParticipationType;
            ticketType: Types.TicketType;
            participantType: {
                code: string;
                id: Types.UUID;
                memberIdRequired: boolean;
                occupationType: Types.OccupationType;
                name: Array<{ locale: string; value: string }>;
                country: {
                    value: string;
                    label: { translations?: Array<{ locale: string; value: string }> | null };
                };
            };
        }>;
        country: {
            value: string;
            label: { translations?: Array<{ locale: string; value: string }> | null };
        };
    } | null;
};

export type ContentDocumentsExtendedQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type ContentDocumentsExtendedQuery = {
    contentDocuments: {
        totalCount?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            endDateTime?: string | null;
            externalId?: string | null;
            contentId: string;
            contentType: Types.ContentType;
            startDateTime?: string | null;
            willBeBroadcasted?: boolean | null;
            isFree?: boolean | null;
            isAvailableOnHomepage?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            locale?: Locale | null;
            title?: string | null;
            city?: Types.JSON | null;
            subtitle?: string | null;
            slug?: string | null;
            specialities: Array<string>;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
            providers: Array<{ name?: string | null; id: Types.UUID }>;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            scientificLeaders: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                level?: number | null;
                subtopicPriority?: number | null;
                abbreviation?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            parent?: {
                locale?: Locale | null;
                isFree?: boolean | null;
                contentId: string;
                contentType: Types.ContentType;
            } | null;
            product?: {
                name?: Types.JSON | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                brand?: Types.ProductBrand | null;
            } | null;
        }>;
    };
};

export type ContentsWithProgramSchedulesQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type ContentsWithProgramSchedulesQuery = {
    contentsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Content';
            location?: string | null;
            headerUrl?: string | null;
            dominantColor?: string | null;
            publishedCountries: Array<string>;
            eventCost?: number | null;
            specialities: Array<string>;
            subtitle?: string | null;
            id: Types.UUID;
            bookmarked?: boolean | null;
            slug?: string | null;
            brand?: Types.ProductBrand | null;
            endDateTime?: string | null;
            externalId?: string | null;
            contentId: string;
            locale?: Locale | null;
            contentType?: Types.ContentType | null;
            startDateTime?: string | null;
            willBeBroadcasted?: boolean | null;
            willBeOnDemand?: boolean | null;
            isFree?: boolean | null;
            isCommercial?: boolean | null;
            isAvailableOnHomepage?: boolean | null;
            isAvailableOnMediathek?: boolean | null;
            isAvailableWithoutEfn?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            description?: Types.JSON | null;
            descriptionTitle?: Types.JSON | null;
            title?: string | null;
            city?: Types.JSON | null;
            order?: number | null;
            isSponsored?: boolean | null;
            rating?: number | null;
            replacementDate?: string | null;
            replacementTitle?: string | null;
            bannerButtonSettings?: { text?: Types.JSON | null; url?: string | null } | null;
            certificate?: {
                reportDate?: string | null;
                reportStatus: Types.ReportStatus;
                file?: {
                    id: Types.UUID;
                    downloadUrl?: string | null;
                    url?: string | null;
                    name?: string | null;
                } | null;
            } | null;
            schedule: Array<{
                id: Types.UUID;
                bookmarked?: boolean | null;
                slug?: string | null;
                brand?: Types.ProductBrand | null;
                endDateTime?: string | null;
                externalId?: string | null;
                contentId: string;
                locale?: Locale | null;
                contentType?: Types.ContentType | null;
                startDateTime?: string | null;
                willBeBroadcasted?: boolean | null;
                willBeOnDemand?: boolean | null;
                isFree?: boolean | null;
                isCommercial?: boolean | null;
                isAvailableOnHomepage?: boolean | null;
                isAvailableOnMediathek?: boolean | null;
                isAvailableWithoutEfn?: boolean | null;
                participationOption?: Types.ContentParticipationOption | null;
                capacityStatus?: Types.ContentCapacityStatus | null;
                description?: Types.JSON | null;
                descriptionTitle?: Types.JSON | null;
                title?: string | null;
                city?: Types.JSON | null;
                order?: number | null;
                headerUrl?: string | null;
                isSponsored?: boolean | null;
                rating?: number | null;
                replacementDate?: string | null;
                replacementTitle?: string | null;
                bannerButtonSettings?: { text?: Types.JSON | null; url?: string | null } | null;
                contentUnit?: { id: Types.UUID; title: string; order?: number | null } | null;
                provider?: {
                    id: Types.UUID;
                    name?: string | null;
                    country?: string | null;
                    logoUrl?: string | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
                contentProgress?: {
                    completed?: boolean | null;
                    contentId: string;
                    time?: number | null;
                    trackedDateTime?: string | null;
                } | null;
                contentUnits: Array<{ id: Types.UUID; title: string; order?: number | null }>;
                membershipSettings: { availableForMembers: boolean };
                detailsPageSettings?: {
                    eventBookable?: boolean | null;
                    sponsorDescription?: Types.JSON | null;
                    redirectThroughExhibition?: boolean | null;
                    showLocation?: boolean | null;
                } | null;
                agendaSettings?: {
                    defaultDescription?: Types.JSON | null;
                    programTemplate?: Types.AgendaProgramTemplate | null;
                    showAgenda?: boolean | null;
                    showProgramOverview?: boolean | null;
                    showSpeakers?: boolean | null;
                } | null;
                accreditationSettings?: {
                    description?: Types.JSON | null;
                    showScheme?: boolean | null;
                    showSection?: boolean | null;
                } | null;
                seoSettings?: {
                    description?: Types.JSON | null;
                    image?: string | null;
                    indexSetting?: Types.SeoIndexSetting | null;
                    title?: Types.JSON | null;
                } | null;
                sponsorships: Array<{
                    __typename: 'Sponsorship';
                    contentId: Types.UUID;
                    description?: Types.JSON | null;
                    id: Types.UUID;
                    sponsorCompanyId?: Types.UUID | null;
                    sponsorshipAmount?: number | null;
                    sponsorshipType?: Types.SponsorshipType | null;
                    virtualExhibition?: boolean | null;
                    symposiumIds: Array<Types.UUID | null>;
                    entireEventSponsor?: boolean | null;
                    participantRestriction: boolean;
                    sponsorCompany?: {
                        id: Types.UUID;
                        name?: string | null;
                        logoUrl?: string | null;
                        websites?: Types.JSON | null;
                        country?: string | null;
                        companyPage?: {
                            id: Types.UUID;
                            slug?: string | null;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null;
                    sponsorDepartments?: Array<{
                        logoUrl?: string | null;
                        id: Types.UUID;
                        companyPage?: {
                            id: Types.UUID;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null> | null;
                    symposiums: Array<{
                        id: Types.UUID;
                        title?: string | null;
                        startDateTime?: string | null;
                        endDateTime?: string | null;
                        externalId?: string | null;
                        sponsorships: Array<{
                            sponsorshipAmount?: number | null;
                            sponsorCompany?: {
                                logoUrl?: string | null;
                                name?: string | null;
                            } | null;
                        }>;
                        speakers: Array<{
                            id: Types.UUID;
                            avatarSrcUrl?: string | null;
                            description?: string | null;
                            gender?: Types.Gender | null;
                            name: string;
                            title?: string | null;
                        }>;
                    } | null>;
                    content?: {
                        __typename: 'Content';
                        id: Types.UUID;
                        bookmarked?: boolean | null;
                        brand?: Types.ProductBrand | null;
                        startDateTime?: string | null;
                        endDateTime?: string | null;
                        contentId: string;
                        contentType?: Types.ContentType | null;
                        locale?: Locale | null;
                        title?: string | null;
                        city?: Types.JSON | null;
                        headerUrl?: string | null;
                        willBeBroadcasted?: boolean | null;
                        rating?: number | null;
                        externalId?: string | null;
                        product?: {
                            name?: Types.JSON | null;
                            description?: Types.JSON | null;
                            specialityIconUrl?: string | null;
                            code: string;
                            id: Types.UUID;
                            country?: string | null;
                            isScientificLeaderEnabled?: boolean | null;
                            descriptionTitle?: Types.JSON | null;
                            targetGroupIds: Array<Types.UUID>;
                            benefitIds: Array<Types.UUID>;
                            iconPrimaryColor: string;
                        } | null;
                        source?: {
                            thumbnail?: string | null;
                            duration?: number | null;
                            url?: string | null;
                            file?: {
                                downloadUrl?: string | null;
                                name?: string | null;
                                thumbnailUrl?: string | null;
                            } | null;
                        } | null;
                        speakers: Array<{
                            id: Types.UUID;
                            avatarSrcUrl?: string | null;
                            description?: string | null;
                            gender?: Types.Gender | null;
                            name: string;
                            title?: string | null;
                        }>;
                    } | null;
                }>;
                partnerships: Array<{
                    id: Types.UUID;
                    partnershipType?: Types.PartnershipType | null;
                    partnerCompany?: { name?: string | null; logoUrl?: string | null } | null;
                }>;
                benefits: Array<{
                    id: Types.UUID;
                    title?: Types.JSON | null;
                    footNote?: Types.JSON | null;
                    iconUrl?: string | null;
                    isFootNoteEnabled?: boolean | null;
                    usage?: Types.BenefitUsage | null;
                }>;
                targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
                product?: {
                    name?: Types.JSON | null;
                    description?: Types.JSON | null;
                    specialityIconUrl?: string | null;
                    code: string;
                    id: Types.UUID;
                    country?: string | null;
                    isScientificLeaderEnabled?: boolean | null;
                    descriptionTitle?: Types.JSON | null;
                    targetGroupIds: Array<Types.UUID>;
                    benefitIds: Array<Types.UUID>;
                    iconPrimaryColor: string;
                    benefits: Array<{
                        id: Types.UUID;
                        title?: Types.JSON | null;
                        footNote?: Types.JSON | null;
                        iconUrl?: string | null;
                        isFootNoteEnabled?: boolean | null;
                        usage?: Types.BenefitUsage | null;
                    }>;
                    targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
                } | null;
                credits: Array<{
                    amount: number;
                    unit: string;
                    isApproved?: boolean | null;
                    accreditationInstitute?: string | null;
                    participationType?: Types.ParticipationType | null;
                }>;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
                topics: Array<{
                    id: Types.UUID;
                    code: string;
                    level?: number | null;
                    subtopicPriority?: number | null;
                    abbreviation?: Types.JSON | null;
                    description?: Types.JSON | null;
                    specialityIconUrl?: string | null;
                    iconPrimaryColor: string;
                    parents: Array<{ code: string }>;
                }>;
                parent?: {
                    locale?: Locale | null;
                    isFree?: boolean | null;
                    sponsorships: Array<{
                        sponsorCompany?: {
                            id: Types.UUID;
                            logoUrl?: string | null;
                            name?: string | null;
                            country?: string | null;
                            companyPage?: {
                                id: Types.UUID;
                                slug?: string | null;
                                publishStatus?: Types.PublishStatusType | null;
                            } | null;
                        } | null;
                        sponsorDepartments?: Array<{
                            logoUrl?: string | null;
                            id: Types.UUID;
                        } | null> | null;
                    }>;
                } | null;
                source?: {
                    thumbnail?: string | null;
                    duration?: number | null;
                    url?: string | null;
                    file?: {
                        downloadUrl?: string | null;
                        name?: string | null;
                        thumbnailUrl?: string | null;
                    } | null;
                } | null;
            }>;
            provider?: {
                id: Types.UUID;
                name?: string | null;
                country?: string | null;
                logoUrl?: string | null;
                companyPage?: {
                    id: Types.UUID;
                    slug?: string | null;
                    publishStatus?: Types.PublishStatusType | null;
                } | null;
            } | null;
            parent?: {
                locale?: Locale | null;
                isFree?: boolean | null;
                id: Types.UUID;
                bookmarked?: boolean | null;
                slug?: string | null;
                brand?: Types.ProductBrand | null;
                endDateTime?: string | null;
                externalId?: string | null;
                contentId: string;
                contentType?: Types.ContentType | null;
                startDateTime?: string | null;
                willBeBroadcasted?: boolean | null;
                willBeOnDemand?: boolean | null;
                isCommercial?: boolean | null;
                isAvailableOnHomepage?: boolean | null;
                isAvailableOnMediathek?: boolean | null;
                isAvailableWithoutEfn?: boolean | null;
                participationOption?: Types.ContentParticipationOption | null;
                capacityStatus?: Types.ContentCapacityStatus | null;
                description?: Types.JSON | null;
                descriptionTitle?: Types.JSON | null;
                title?: string | null;
                city?: Types.JSON | null;
                order?: number | null;
                headerUrl?: string | null;
                isSponsored?: boolean | null;
                rating?: number | null;
                replacementDate?: string | null;
                replacementTitle?: string | null;
                sponsorships: Array<{
                    __typename: 'Sponsorship';
                    contentId: Types.UUID;
                    description?: Types.JSON | null;
                    id: Types.UUID;
                    sponsorCompanyId?: Types.UUID | null;
                    sponsorshipAmount?: number | null;
                    sponsorshipType?: Types.SponsorshipType | null;
                    virtualExhibition?: boolean | null;
                    symposiumIds: Array<Types.UUID | null>;
                    entireEventSponsor?: boolean | null;
                    participantRestriction: boolean;
                    sponsorCompany?: {
                        id: Types.UUID;
                        logoUrl?: string | null;
                        name?: string | null;
                        country?: string | null;
                        websites?: Types.JSON | null;
                        companyPage?: {
                            id: Types.UUID;
                            slug?: string | null;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null;
                    sponsorDepartments?: Array<{
                        logoUrl?: string | null;
                        id: Types.UUID;
                        companyPage?: {
                            id: Types.UUID;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null> | null;
                    symposiums: Array<{
                        id: Types.UUID;
                        title?: string | null;
                        startDateTime?: string | null;
                        endDateTime?: string | null;
                        externalId?: string | null;
                        sponsorships: Array<{
                            sponsorshipAmount?: number | null;
                            sponsorCompany?: {
                                logoUrl?: string | null;
                                name?: string | null;
                            } | null;
                        }>;
                        speakers: Array<{
                            id: Types.UUID;
                            avatarSrcUrl?: string | null;
                            description?: string | null;
                            gender?: Types.Gender | null;
                            name: string;
                            title?: string | null;
                        }>;
                    } | null>;
                    content?: {
                        __typename: 'Content';
                        id: Types.UUID;
                        bookmarked?: boolean | null;
                        brand?: Types.ProductBrand | null;
                        startDateTime?: string | null;
                        endDateTime?: string | null;
                        contentId: string;
                        contentType?: Types.ContentType | null;
                        locale?: Locale | null;
                        title?: string | null;
                        city?: Types.JSON | null;
                        headerUrl?: string | null;
                        willBeBroadcasted?: boolean | null;
                        rating?: number | null;
                        externalId?: string | null;
                        product?: {
                            name?: Types.JSON | null;
                            description?: Types.JSON | null;
                            specialityIconUrl?: string | null;
                            code: string;
                            id: Types.UUID;
                            country?: string | null;
                            isScientificLeaderEnabled?: boolean | null;
                            descriptionTitle?: Types.JSON | null;
                            targetGroupIds: Array<Types.UUID>;
                            benefitIds: Array<Types.UUID>;
                            iconPrimaryColor: string;
                        } | null;
                        source?: {
                            thumbnail?: string | null;
                            duration?: number | null;
                            url?: string | null;
                            file?: {
                                downloadUrl?: string | null;
                                name?: string | null;
                                thumbnailUrl?: string | null;
                            } | null;
                        } | null;
                        speakers: Array<{
                            id: Types.UUID;
                            avatarSrcUrl?: string | null;
                            description?: string | null;
                            gender?: Types.Gender | null;
                            name: string;
                            title?: string | null;
                        }>;
                    } | null;
                }>;
                contentUnit?: { id: Types.UUID; title: string; order?: number | null } | null;
                provider?: {
                    id: Types.UUID;
                    name?: string | null;
                    country?: string | null;
                    logoUrl?: string | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
                contentProgress?: {
                    completed?: boolean | null;
                    contentId: string;
                    time?: number | null;
                    trackedDateTime?: string | null;
                } | null;
                contentUnits: Array<{ id: Types.UUID; title: string; order?: number | null }>;
                membershipSettings: { availableForMembers: boolean };
                detailsPageSettings?: {
                    eventBookable?: boolean | null;
                    sponsorDescription?: Types.JSON | null;
                    redirectThroughExhibition?: boolean | null;
                    showLocation?: boolean | null;
                } | null;
                agendaSettings?: {
                    defaultDescription?: Types.JSON | null;
                    programTemplate?: Types.AgendaProgramTemplate | null;
                    showAgenda?: boolean | null;
                    showProgramOverview?: boolean | null;
                    showSpeakers?: boolean | null;
                } | null;
                accreditationSettings?: {
                    description?: Types.JSON | null;
                    showScheme?: boolean | null;
                    showSection?: boolean | null;
                } | null;
                seoSettings?: {
                    description?: Types.JSON | null;
                    image?: string | null;
                    indexSetting?: Types.SeoIndexSetting | null;
                    title?: Types.JSON | null;
                } | null;
                partnerships: Array<{
                    id: Types.UUID;
                    partnershipType?: Types.PartnershipType | null;
                    partnerCompany?: { name?: string | null; logoUrl?: string | null } | null;
                }>;
                benefits: Array<{
                    id: Types.UUID;
                    title?: Types.JSON | null;
                    footNote?: Types.JSON | null;
                    iconUrl?: string | null;
                    isFootNoteEnabled?: boolean | null;
                    usage?: Types.BenefitUsage | null;
                }>;
                targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
                product?: {
                    name?: Types.JSON | null;
                    description?: Types.JSON | null;
                    specialityIconUrl?: string | null;
                    code: string;
                    id: Types.UUID;
                    country?: string | null;
                    isScientificLeaderEnabled?: boolean | null;
                    descriptionTitle?: Types.JSON | null;
                    targetGroupIds: Array<Types.UUID>;
                    benefitIds: Array<Types.UUID>;
                    iconPrimaryColor: string;
                    benefits: Array<{
                        id: Types.UUID;
                        title?: Types.JSON | null;
                        footNote?: Types.JSON | null;
                        iconUrl?: string | null;
                        isFootNoteEnabled?: boolean | null;
                        usage?: Types.BenefitUsage | null;
                    }>;
                    targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
                } | null;
                credits: Array<{
                    amount: number;
                    unit: string;
                    isApproved?: boolean | null;
                    accreditationInstitute?: string | null;
                    participationType?: Types.ParticipationType | null;
                }>;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
                topics: Array<{
                    id: Types.UUID;
                    code: string;
                    level?: number | null;
                    subtopicPriority?: number | null;
                    abbreviation?: Types.JSON | null;
                    description?: Types.JSON | null;
                    specialityIconUrl?: string | null;
                    iconPrimaryColor: string;
                    parents: Array<{ code: string }>;
                }>;
                parent?: {
                    locale?: Locale | null;
                    isFree?: boolean | null;
                    sponsorships: Array<{
                        sponsorCompany?: {
                            id: Types.UUID;
                            logoUrl?: string | null;
                            name?: string | null;
                            country?: string | null;
                            companyPage?: {
                                id: Types.UUID;
                                slug?: string | null;
                                publishStatus?: Types.PublishStatusType | null;
                            } | null;
                        } | null;
                        sponsorDepartments?: Array<{
                            logoUrl?: string | null;
                            id: Types.UUID;
                        } | null> | null;
                    }>;
                } | null;
                source?: {
                    thumbnail?: string | null;
                    duration?: number | null;
                    url?: string | null;
                    file?: {
                        downloadUrl?: string | null;
                        name?: string | null;
                        thumbnailUrl?: string | null;
                    } | null;
                } | null;
            } | null;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            scientificLeaders: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            scientificCoLeaders: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            programSchedules: Array<{
                symposiumPublishedDomains?: Array<string> | null;
                externalId?: string | null;
                id: Types.UUID;
                title?: string | null;
                startDateTime?: string | null;
                endDateTime?: string | null;
                level?: number | null;
                scheduleType?: Types.ProgramScheduleType | null;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
                sponsorships: Array<{
                    sponsorshipAmount?: number | null;
                    sponsorCompany?: {
                        id: Types.UUID;
                        name?: string | null;
                        country?: string | null;
                        logoUrl?: string | null;
                        companyPage?: {
                            id: Types.UUID;
                            slug?: string | null;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null;
                }>;
            }>;
            attachments: Array<{
                attachmentType?: Types.AttachmentType | null;
                contentId: Types.UUID;
                fileId?: Types.UUID | null;
                groupId?: string | null;
                id: Types.UUID;
                file?: {
                    downloadUrl?: string | null;
                    id: Types.UUID;
                    mimetype?: string | null;
                    name?: string | null;
                    shortUrl?: string | null;
                    size?: number | null;
                    uploadUrl?: string | null;
                    url?: string | null;
                    permissions: Array<{
                        id?: Types.UUID | null;
                        permissionType?: Types.PermissionType | null;
                        scope?: Types.JSON | null;
                    } | null>;
                } | null;
            }>;
            sponsorships: Array<{
                __typename: 'Sponsorship';
                contentId: Types.UUID;
                description?: Types.JSON | null;
                id: Types.UUID;
                sponsorCompanyId?: Types.UUID | null;
                sponsorshipAmount?: number | null;
                sponsorshipType?: Types.SponsorshipType | null;
                virtualExhibition?: boolean | null;
                symposiumIds: Array<Types.UUID | null>;
                entireEventSponsor?: boolean | null;
                participantRestriction: boolean;
                sponsorDepartments?: Array<{
                    logoUrl?: string | null;
                    id: Types.UUID;
                    translatedName?: Types.JSON | null;
                    companyPage?: {
                        id: Types.UUID;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null> | null;
                sponsorCompany?: {
                    id: Types.UUID;
                    logoUrl?: string | null;
                    name?: string | null;
                    country?: string | null;
                    websites?: Types.JSON | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
                symposiums: Array<{
                    id: Types.UUID;
                    title?: string | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    externalId?: string | null;
                    sponsorships: Array<{
                        sponsorshipAmount?: number | null;
                        sponsorCompany?: { logoUrl?: string | null; name?: string | null } | null;
                    }>;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null>;
                content?: {
                    __typename: 'Content';
                    id: Types.UUID;
                    bookmarked?: boolean | null;
                    brand?: Types.ProductBrand | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    contentId: string;
                    contentType?: Types.ContentType | null;
                    locale?: Locale | null;
                    title?: string | null;
                    city?: Types.JSON | null;
                    headerUrl?: string | null;
                    willBeBroadcasted?: boolean | null;
                    rating?: number | null;
                    externalId?: string | null;
                    product?: {
                        name?: Types.JSON | null;
                        description?: Types.JSON | null;
                        specialityIconUrl?: string | null;
                        code: string;
                        id: Types.UUID;
                        country?: string | null;
                        isScientificLeaderEnabled?: boolean | null;
                        descriptionTitle?: Types.JSON | null;
                        targetGroupIds: Array<Types.UUID>;
                        benefitIds: Array<Types.UUID>;
                        iconPrimaryColor: string;
                    } | null;
                    source?: {
                        thumbnail?: string | null;
                        duration?: number | null;
                        url?: string | null;
                        file?: {
                            downloadUrl?: string | null;
                            name?: string | null;
                            thumbnailUrl?: string | null;
                        } | null;
                    } | null;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null;
            }>;
            contentUnit?: { id: Types.UUID; title: string; order?: number | null } | null;
            contentProgress?: {
                completed?: boolean | null;
                contentId: string;
                time?: number | null;
                trackedDateTime?: string | null;
            } | null;
            contentUnits: Array<{ id: Types.UUID; title: string; order?: number | null }>;
            membershipSettings: { availableForMembers: boolean };
            detailsPageSettings?: {
                eventBookable?: boolean | null;
                sponsorDescription?: Types.JSON | null;
                redirectThroughExhibition?: boolean | null;
                showLocation?: boolean | null;
            } | null;
            agendaSettings?: {
                defaultDescription?: Types.JSON | null;
                programTemplate?: Types.AgendaProgramTemplate | null;
                showAgenda?: boolean | null;
                showProgramOverview?: boolean | null;
                showSpeakers?: boolean | null;
            } | null;
            accreditationSettings?: {
                description?: Types.JSON | null;
                showScheme?: boolean | null;
                showSection?: boolean | null;
            } | null;
            seoSettings?: {
                description?: Types.JSON | null;
                image?: string | null;
                indexSetting?: Types.SeoIndexSetting | null;
                title?: Types.JSON | null;
            } | null;
            partnerships: Array<{
                id: Types.UUID;
                partnershipType?: Types.PartnershipType | null;
                partnerCompany?: { name?: string | null; logoUrl?: string | null } | null;
            }>;
            benefits: Array<{
                id: Types.UUID;
                title?: Types.JSON | null;
                footNote?: Types.JSON | null;
                iconUrl?: string | null;
                isFootNoteEnabled?: boolean | null;
                usage?: Types.BenefitUsage | null;
            }>;
            targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
            product?: {
                name?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                code: string;
                id: Types.UUID;
                country?: string | null;
                isScientificLeaderEnabled?: boolean | null;
                descriptionTitle?: Types.JSON | null;
                targetGroupIds: Array<Types.UUID>;
                benefitIds: Array<Types.UUID>;
                iconPrimaryColor: string;
                benefits: Array<{
                    id: Types.UUID;
                    title?: Types.JSON | null;
                    footNote?: Types.JSON | null;
                    iconUrl?: string | null;
                    isFootNoteEnabled?: boolean | null;
                    usage?: Types.BenefitUsage | null;
                }>;
                targetGroups: Array<{ id: Types.UUID; title?: Types.JSON | null }>;
            } | null;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            topics: Array<{
                id: Types.UUID;
                code: string;
                level?: number | null;
                subtopicPriority?: number | null;
                abbreviation?: Types.JSON | null;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                parents: Array<{ code: string }>;
            }>;
            source?: {
                thumbnail?: string | null;
                duration?: number | null;
                url?: string | null;
                file?: {
                    downloadUrl?: string | null;
                    name?: string | null;
                    thumbnailUrl?: string | null;
                } | null;
            } | null;
        }>;
    };
};

export type PartnerForumAllCompanyVideosQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type PartnerForumAllCompanyVideosQuery = {
    contentsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            id: Types.UUID;
            contentId: string;
            contentType?: Types.ContentType | null;
            replacementDate?: string | null;
            brand?: Types.ProductBrand | null;
            headerUrl?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            title?: string | null;
            isFree?: boolean | null;
            isCommercial?: boolean | null;
            order?: number | null;
            rating?: number | null;
            bookmarked?: boolean | null;
            isSponsored?: boolean | null;
            isAvailableOnMediathek?: boolean | null;
            isAvailableWithoutEfn?: boolean | null;
            bannerButtonSettings?: { text?: Types.JSON | null; url?: string | null } | null;
            contentUnit?: { order?: number | null; title: string; id: Types.UUID } | null;
            speakers: Array<{
                id: Types.UUID;
                title?: string | null;
                name: string;
                avatarSrcUrl?: string | null;
                description?: string | null;
            }>;
            source?: {
                duration?: number | null;
                url?: string | null;
                thumbnail?: string | null;
                file?: { downloadUrl?: string | null; name?: string | null } | null;
            } | null;
            product?: {
                name?: Types.JSON | null;
                code: string;
                specialityIconUrl?: string | null;
            } | null;
            provider?: { id: Types.UUID; name?: string | null; logoUrl?: string | null } | null;
            contentProgress?: { completed?: boolean | null; time?: number | null } | null;
            sponsorships: Array<{
                participantRestriction: boolean;
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                } | null;
                sponsorDepartments?: Array<{
                    id: Types.UUID;
                    logoUrl?: string | null;
                } | null> | null;
            }>;
            parent?: {
                isFree?: boolean | null;
                sponsorships: Array<{
                    sponsorCompany?: {
                        id: Types.UUID;
                        name?: string | null;
                        logoUrl?: string | null;
                    } | null;
                    sponsorDepartments?: Array<{
                        id: Types.UUID;
                        logoUrl?: string | null;
                    } | null> | null;
                }>;
            } | null;
        }>;
    };
};

export type PartnerForumOverviewVideosQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type PartnerForumOverviewVideosQuery = {
    contentsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'Content';
            id: Types.UUID;
            bookmarked?: boolean | null;
            contentType?: Types.ContentType | null;
            contentId: string;
            brand?: Types.ProductBrand | null;
            startDateTime?: string | null;
            title?: string | null;
            isCommercial?: boolean | null;
            rating?: number | null;
            parent?: {
                title?: string | null;
                brand?: Types.ProductBrand | null;
                city?: Types.JSON | null;
                contentType?: Types.ContentType | null;
                startDateTime?: string | null;
            } | null;
            source?: { thumbnail?: string | null } | null;
        }>;
    };
};

export type SimpleContentsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type SimpleContentsQuery = {
    contentsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            id: Types.UUID;
            brand?: Types.ProductBrand | null;
            title?: string | null;
            externalId?: string | null;
            contentId: string;
            subtitle?: string | null;
            provider?: { id: Types.UUID } | null;
        }>;
    };
};

export type GetCompanyQueryVariables = Types.Exact<{
    id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
    domain?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetCompanyQuery = {
    company: {
        id: Types.UUID;
        name?: string | null;
        logoUrl?: string | null;
        description?: string | null;
        city?: string | null;
        country?: string | null;
        postalCode?: string | null;
        phone?: string | null;
        email?: string | null;
        websites?: Types.JSON | null;
        ubAccountCode?: string | null;
        address?: string | null;
        companyType?: Types.CompanyType | null;
        fax?: string | null;
        phoneNumbers?: Array<string | null> | null;
        additionalContactDescription?: Types.JSON | null;
        links: Array<{
            name?: string | null;
            type?: Types.CompanyLinkType | null;
            url?: string | null;
            locales: Array<string>;
            order?: number | null;
        }>;
        companyContacts: Array<{
            name?: string | null;
            email?: string | null;
            description?: string | null;
            translatedDescription?: Types.JSON | null;
            phone?: string | null;
            avatarSrcUrl?: string | null;
            locales: Array<string>;
        }>;
        companyPage?: {
            id: Types.UUID;
            publishStatus?: Types.PublishStatusType | null;
            descriptionHeader?: Types.JSON | null;
            descriptionBody?: Types.JSON | null;
            shortLink?: string | null;
            directLink?: string | null;
            slug?: string | null;
            isContactSectionHidden?: boolean | null;
            customTitle?: Types.JSON | null;
        } | null;
        departments: Array<{
            id: Types.UUID;
            translatedName?: Types.JSON | null;
            logoUrl?: string | null;
            links: Array<{
                name?: string | null;
                type?: Types.CompanyLinkType | null;
                url?: string | null;
                locales: Array<string>;
                order?: number | null;
            }>;
            companyContacts: Array<{
                name?: string | null;
                email?: string | null;
                description?: string | null;
                translatedDescription?: Types.JSON | null;
                phone?: string | null;
                avatarSrcUrl?: string | null;
                locales: Array<string>;
            }>;
            companyPage?: {
                id: Types.UUID;
                publishStatus?: Types.PublishStatusType | null;
                descriptionHeader?: Types.JSON | null;
                descriptionBody?: Types.JSON | null;
                shortLink?: string | null;
                directLink?: string | null;
                slug?: string | null;
                isContactSectionHidden?: boolean | null;
                customTitle?: Types.JSON | null;
            } | null;
        }>;
    };
};

export type GetCompanyBasicDataQueryVariables = Types.Exact<{
    id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
    domain?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetCompanyBasicDataQuery = {
    company: { id: Types.UUID; name?: string | null; logoUrl?: string | null };
};

export type MediathekCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type MediathekCoursesQuery = {
    contentDocuments: {
        totalCount?: number | null;
        data: Array<{
            brand?: Types.ProductBrand | null;
            subtitle?: string | null;
            contentId: string;
            slug?: string | null;
            externalId?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            city?: Types.JSON | null;
            id: Types.UUID;
            locale?: Locale | null;
            contentType: Types.ContentType;
            willBeBroadcasted?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            specialities: Array<string>;
            title?: string | null;
            product?: {
                id: Types.UUID;
                name?: Types.JSON | null;
                code: string;
                brand?: Types.ProductBrand | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                topics: Array<{ id: Types.UUID; code: string }>;
            } | null;
            credits: Array<{
                participationType?: Types.ParticipationType | null;
                isApproved?: boolean | null;
                amount: number;
                unit: string;
            }>;
        }>;
        aggregations?: Array<{
            name: string;
            buckets?: Array<{ key?: string | null; value?: string | null } | null> | null;
        } | null> | null;
    };
};

export type GetUserPaymentStatusQueryVariables = Types.Exact<{
    paymentReference: Types.Scalars['String']['input'];
    userId: Types.Scalars['ID']['input'];
    tenantId?: Types.Scalars['ID']['input'];
}>;

export type GetUserPaymentStatusQuery = {
    userPaymentStatus: { paymentStatus: Types.PaymentStatus };
};

export type GetTenantPartnerCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type GetTenantPartnerCoursesQuery = {
    contentDocuments: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            id: Types.UUID;
            contentType: Types.ContentType;
            contentId: string;
            brand?: Types.ProductBrand | null;
            startDateTime?: string | null;
            title?: string | null;
            subtitle?: string | null;
            slug?: string | null;
            externalId?: string | null;
            endDateTime?: string | null;
            city?: Types.JSON | null;
            locale?: Locale | null;
            willBeBroadcasted?: boolean | null;
            participationOption?: Types.ContentParticipationOption | null;
            capacityStatus?: Types.ContentCapacityStatus | null;
            specialities: Array<string>;
            product?: {
                id: Types.UUID;
                name?: Types.JSON | null;
                code: string;
                brand?: Types.ProductBrand | null;
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                topics: Array<{ id: Types.UUID; code: string }>;
            } | null;
            credits: Array<{
                participationType?: Types.ParticipationType | null;
                isApproved?: boolean | null;
                amount: number;
                unit: string;
            }>;
        }>;
    };
};

export type GetUserRemindersForEventQueryVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
    eventUbId: Types.Scalars['String']['input'];
}>;

export type GetUserRemindersForEventQuery = {
    getUserRemindersForEvent: {
        items: Array<{ id: Types.UUID; reminderChannel: Types.ReminderChannel }>;
    };
};

export type GetHandoutsLandingCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetHandoutsLandingCoursesQuery = {
    contentsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            id: Types.UUID;
            title?: string | null;
            startDateTime?: string | null;
            bookmarked?: boolean | null;
            contentType?: Types.ContentType | null;
            brand?: Types.ProductBrand | null;
            slug?: string | null;
            cityV2?: { name?: Types.JSON | null; id: Types.UUID; imageUrl?: string | null } | null;
            product?: {
                iconPrimaryColor: string;
                description?: Types.JSON | null;
                specialityIconUrl?: string | null;
            } | null;
            topics: Array<{
                id: Types.UUID;
                specialityIconUrl?: string | null;
                description?: Types.JSON | null;
                iconPrimaryColor: string;
                abbreviation?: Types.JSON | null;
                code: string;
            }>;
        }>;
    };
};

export type GetTopicsForQueryFilterQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetTopicsForQueryFilterQuery = {
    topicDocuments: {
        data: Array<{
            id: Types.UUID;
            specialityIconUrl?: string | null;
            description?: Types.JSON | null;
            iconPrimaryColor: string;
            abbreviation?: Types.JSON | null;
            code: string;
        }>;
    };
};

export type GetHandoutsDetailsQueryVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
}>;

export type GetHandoutsDetailsQuery = {
    content: {
        id: Types.UUID;
        title?: string | null;
        description?: Types.JSON | null;
        externalId?: string | null;
        contentId: string;
        city?: Types.JSON | null;
        contentType?: Types.ContentType | null;
        startDateTime?: string | null;
        bookmarked?: boolean | null;
        endDateTime?: string | null;
        seoSettings?: { title?: Types.JSON | null; description?: Types.JSON | null } | null;
        agendaSettings?: {
            showAgenda?: boolean | null;
            defaultDescription?: Types.JSON | null;
            programTemplate?: Types.AgendaProgramTemplate | null;
        } | null;
        product?: { code: string } | null;
        topics: Array<{ id: Types.UUID; code: string; description?: Types.JSON | null }>;
        scientificLeaders: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        scientificCoLeaders: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        speakers: Array<{
            id: Types.UUID;
            avatarSrcUrl?: string | null;
            description?: string | null;
            gender?: Types.Gender | null;
            name: string;
            title?: string | null;
        }>;
        programSchedules: Array<{
            id: Types.UUID;
            scheduleType?: Types.ProgramScheduleType | null;
            title?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            speakers: Array<{
                id: Types.UUID;
                avatarSrcUrl?: string | null;
                description?: string | null;
                gender?: Types.Gender | null;
                name: string;
                title?: string | null;
            }>;
            sponsorships: Array<{
                __typename: 'Sponsorship';
                contentId: Types.UUID;
                description?: Types.JSON | null;
                id: Types.UUID;
                sponsorCompanyId?: Types.UUID | null;
                sponsorshipAmount?: number | null;
                sponsorshipType?: Types.SponsorshipType | null;
                virtualExhibition?: boolean | null;
                symposiumIds: Array<Types.UUID | null>;
                entireEventSponsor?: boolean | null;
                participantRestriction: boolean;
                sponsorCompany?: {
                    id: Types.UUID;
                    name?: string | null;
                    logoUrl?: string | null;
                    websites?: Types.JSON | null;
                    country?: string | null;
                    companyPage?: {
                        id: Types.UUID;
                        slug?: string | null;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null;
                sponsorDepartments?: Array<{
                    logoUrl?: string | null;
                    id: Types.UUID;
                    companyPage?: {
                        id: Types.UUID;
                        publishStatus?: Types.PublishStatusType | null;
                    } | null;
                } | null> | null;
                symposiums: Array<{
                    id: Types.UUID;
                    title?: string | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    externalId?: string | null;
                    sponsorships: Array<{
                        sponsorshipAmount?: number | null;
                        sponsorCompany?: { logoUrl?: string | null; name?: string | null } | null;
                    }>;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null>;
                content?: {
                    __typename: 'Content';
                    id: Types.UUID;
                    bookmarked?: boolean | null;
                    brand?: Types.ProductBrand | null;
                    startDateTime?: string | null;
                    endDateTime?: string | null;
                    contentId: string;
                    contentType?: Types.ContentType | null;
                    locale?: Locale | null;
                    title?: string | null;
                    city?: Types.JSON | null;
                    headerUrl?: string | null;
                    willBeBroadcasted?: boolean | null;
                    rating?: number | null;
                    externalId?: string | null;
                    product?: {
                        name?: Types.JSON | null;
                        description?: Types.JSON | null;
                        specialityIconUrl?: string | null;
                        code: string;
                        id: Types.UUID;
                        country?: string | null;
                        isScientificLeaderEnabled?: boolean | null;
                        descriptionTitle?: Types.JSON | null;
                        targetGroupIds: Array<Types.UUID>;
                        benefitIds: Array<Types.UUID>;
                        iconPrimaryColor: string;
                    } | null;
                    source?: {
                        thumbnail?: string | null;
                        duration?: number | null;
                        url?: string | null;
                        file?: {
                            downloadUrl?: string | null;
                            name?: string | null;
                            thumbnailUrl?: string | null;
                        } | null;
                    } | null;
                    speakers: Array<{
                        id: Types.UUID;
                        avatarSrcUrl?: string | null;
                        description?: string | null;
                        gender?: Types.Gender | null;
                        name: string;
                        title?: string | null;
                    }>;
                } | null;
            }>;
        }>;
    };
};

export type GetDetailsPageHandoutsCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetDetailsPageHandoutsCoursesQuery = {
    contentsV2: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            id: Types.UUID;
            isFree?: boolean | null;
            title?: string | null;
            city?: Types.JSON | null;
            contentType?: Types.ContentType | null;
            brand?: Types.ProductBrand | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            slug?: string | null;
            externalId?: string | null;
            headerUrl?: string | null;
            contentId: string;
            bookmarked?: boolean | null;
            parent?: { isFree?: boolean | null } | null;
            topics: Array<{
                specialityIconUrl?: string | null;
                iconPrimaryColor: string;
                code: string;
            }>;
            credits: Array<{
                amount: number;
                unit: string;
                isApproved?: boolean | null;
                accreditationInstitute?: string | null;
                participationType?: Types.ParticipationType | null;
            }>;
            product?: { specialityIconUrl?: string | null; iconPrimaryColor: string } | null;
        }>;
    };
};

export type GetHandoutsCourseBookQueryQueryVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
}>;

export type GetHandoutsCourseBookQueryQuery = {
    content: {
        id: Types.UUID;
        contentId: string;
        title?: string | null;
        city?: Types.JSON | null;
        externalId?: string | null;
        bookmarked?: boolean | null;
        startDateTime?: string | null;
        endDateTime?: string | null;
        attachments: Array<{
            id: Types.UUID;
            attachmentType?: Types.AttachmentType | null;
            file?: { name?: string | null; downloadUrl?: string | null; id: Types.UUID } | null;
        }>;
    };
};

export type GetHandoutsCourseNotesQueryVariables = Types.Exact<{
    contentMediaId: Types.Scalars['String']['input'];
}>;

export type GetHandoutsCourseNotesQuery = {
    contentNotes?: Array<{
        id: number;
        message: string;
        quote?: string | null;
        highlightAreas?: Array<{
            pageIndex: number;
            top: number;
            left: number;
            height: number;
            width: number;
        }> | null;
    } | null> | null;
};

export type GetHandoutsFiltersAggregationsQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetHandoutsFiltersAggregationsQuery = {
    contentsV2: {
        totalCount?: number | null;
        aggregations?: Array<{
            name: string;
            buckets?: Array<{ key?: string | null; value?: string | null } | null> | null;
        } | null> | null;
    };
};

export type GetTrendsByTopicQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type GetTrendsByTopicQuery = {
    recommendedContents: {
        totalCount?: number | null;
        pageNumber?: number | null;
        pageSize?: number | null;
        data: Array<{
            __typename: 'ContentDocument';
            id: Types.UUID;
            contentId: string;
            title?: string | null;
            contentType: Types.ContentType;
            rating?: number | null;
            bookmarked?: boolean | null;
            slug?: string | null;
            startDateTime?: string | null;
            endDateTime?: string | null;
            externalId?: string | null;
            isFree?: boolean | null;
            source?: { thumbnail?: string | null } | null;
            speakers: Array<{ id: Types.UUID; name: string }>;
            parent?: {
                contentType: Types.ContentType;
                contentId: string;
                isFree?: boolean | null;
            } | null;
        }>;
    };
};

export type PartnerForFiltersQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type PartnerForFiltersQuery = {
    partnerCompanies: {
        totalCount?: number | null;
        data: Array<{ id: Types.UUID; name?: string | null }>;
    };
};

export type GetPartnersTopicAggregationsQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type GetPartnersTopicAggregationsQuery = {
    contentDocuments: {
        totalCount?: number | null;
        aggregations?: Array<{
            name: string;
            buckets?: Array<{ key?: string | null; value?: string | null } | null> | null;
        } | null> | null;
    };
};

export type SupportedAcademicEmailDomainsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SupportedAcademicEmailDomainsQuery = {
    supportedAcademicEmailDomains?: Array<string> | null;
};

export type GetPjTrainingCoursesQueryVariables = Types.Exact<{
    searchQuery: Types.SearchQuery;
}>;

export type GetPjTrainingCoursesQuery = {
    contentsV3: {
        data: Array<{
            id: Types.UUID;
            title?: string | null;
            slug?: string | null;
            contentProgress?: { completedPercent: number } | null;
            modules: Array<{ id: Types.UUID; title?: string | null }>;
            contentMedias: Array<{
                module?: { id: Types.UUID } | null;
                contentMediaProgress?: { completed?: boolean | null } | null;
            }>;
            programSchedules: Array<{
                id: Types.UUID;
                scheduleType?: Types.ProgramScheduleType | null;
                title?: string | null;
                startDateTime?: string | null;
                endDateTime?: string | null;
                speakers: Array<{
                    id: Types.UUID;
                    avatarSrcUrl?: string | null;
                    description?: string | null;
                    gender?: Types.Gender | null;
                    name: string;
                    title?: string | null;
                }>;
                sponsorships: Array<{
                    __typename: 'Sponsorship';
                    contentId: Types.UUID;
                    description?: Types.JSON | null;
                    id: Types.UUID;
                    sponsorCompanyId?: Types.UUID | null;
                    sponsorshipAmount?: number | null;
                    sponsorshipType?: Types.SponsorshipType | null;
                    virtualExhibition?: boolean | null;
                    symposiumIds: Array<Types.UUID | null>;
                    entireEventSponsor?: boolean | null;
                    participantRestriction: boolean;
                    sponsorCompany?: {
                        id: Types.UUID;
                        name?: string | null;
                        logoUrl?: string | null;
                        websites?: Types.JSON | null;
                        country?: string | null;
                        companyPage?: {
                            id: Types.UUID;
                            slug?: string | null;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null;
                    sponsorDepartments?: Array<{
                        logoUrl?: string | null;
                        id: Types.UUID;
                        companyPage?: {
                            id: Types.UUID;
                            publishStatus?: Types.PublishStatusType | null;
                        } | null;
                    } | null> | null;
                    symposiums: Array<{
                        id: Types.UUID;
                        title?: string | null;
                        startDateTime?: string | null;
                        endDateTime?: string | null;
                        externalId?: string | null;
                        sponsorships: Array<{
                            sponsorshipAmount?: number | null;
                            sponsorCompany?: {
                                logoUrl?: string | null;
                                name?: string | null;
                            } | null;
                        }>;
                        speakers: Array<{
                            id: Types.UUID;
                            avatarSrcUrl?: string | null;
                            description?: string | null;
                            gender?: Types.Gender | null;
                            name: string;
                            title?: string | null;
                        }>;
                    } | null>;
                    content?: {
                        __typename: 'Content';
                        id: Types.UUID;
                        bookmarked?: boolean | null;
                        brand?: Types.ProductBrand | null;
                        startDateTime?: string | null;
                        endDateTime?: string | null;
                        contentId: string;
                        contentType?: Types.ContentType | null;
                        locale?: Locale | null;
                        title?: string | null;
                        city?: Types.JSON | null;
                        headerUrl?: string | null;
                        willBeBroadcasted?: boolean | null;
                        rating?: number | null;
                        externalId?: string | null;
                        product?: {
                            name?: Types.JSON | null;
                            description?: Types.JSON | null;
                            specialityIconUrl?: string | null;
                            code: string;
                            id: Types.UUID;
                            country?: string | null;
                            isScientificLeaderEnabled?: boolean | null;
                            descriptionTitle?: Types.JSON | null;
                            targetGroupIds: Array<Types.UUID>;
                            benefitIds: Array<Types.UUID>;
                            iconPrimaryColor: string;
                        } | null;
                        source?: {
                            thumbnail?: string | null;
                            duration?: number | null;
                            url?: string | null;
                            file?: {
                                downloadUrl?: string | null;
                                name?: string | null;
                                thumbnailUrl?: string | null;
                            } | null;
                        } | null;
                        speakers: Array<{
                            id: Types.UUID;
                            avatarSrcUrl?: string | null;
                            description?: string | null;
                            gender?: Types.Gender | null;
                            name: string;
                            title?: string | null;
                        }>;
                    } | null;
                }>;
            }>;
        }>;
    };
};

export type GetPartnerTenantVideosQueryVariables = Types.Exact<{
    searchQuery: Types.ContentSearchInput;
}>;

export type GetPartnerTenantVideosQuery = {
    contentDocuments: {
        totalCount?: number | null;
        data: Array<{
            id: Types.UUID;
            title?: string | null;
            contentType: Types.ContentType;
            contentId: string;
            source?: { thumbnail?: string | null; duration?: number | null } | null;
            parent?: { contentId: string } | null;
            topics: Array<{
                code: string;
                description?: Types.JSON | null;
                abbreviation?: Types.JSON | null;
            }>;
        }>;
    };
};

/**
 * __useTopicSortOrderQuery__
 *
 * To run a query within a React component, call `useTopicSortOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicSortOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicSortOrderQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTopicSortOrderQuery(
    baseOptions?: Apollo.QueryHookOptions<TopicSortOrderQuery, TopicSortOrderQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<TopicSortOrderQuery, TopicSortOrderQueryVariables>(
        Operations.TopicSortOrder,
        options
    );
}
export function useTopicSortOrderLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<TopicSortOrderQuery, TopicSortOrderQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<TopicSortOrderQuery, TopicSortOrderQueryVariables>(
        Operations.TopicSortOrder,
        options
    );
}
export function useTopicSortOrderSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<TopicSortOrderQuery, TopicSortOrderQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<TopicSortOrderQuery, TopicSortOrderQueryVariables>(
        Operations.TopicSortOrder,
        options
    );
}
export type TopicSortOrderQueryHookResult = ReturnType<typeof useTopicSortOrderQuery>;
export type TopicSortOrderLazyQueryHookResult = ReturnType<typeof useTopicSortOrderLazyQuery>;
export type TopicSortOrderSuspenseQueryHookResult = ReturnType<
    typeof useTopicSortOrderSuspenseQuery
>;
export type TopicSortOrderQueryResult = Apollo.QueryResult<
    TopicSortOrderQuery,
    TopicSortOrderQueryVariables
>;

/**
 * __useCurrentUserSpecialityQuery__
 *
 * To run a query within a React component, call `useCurrentUserSpecialityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserSpecialityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserSpecialityQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserSpecialityQuery(
    baseOptions?: Apollo.QueryHookOptions<
        CurrentUserSpecialityQuery,
        CurrentUserSpecialityQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<CurrentUserSpecialityQuery, CurrentUserSpecialityQueryVariables>(
        Operations.CurrentUserSpeciality,
        options
    );
}
export function useCurrentUserSpecialityLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        CurrentUserSpecialityQuery,
        CurrentUserSpecialityQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<CurrentUserSpecialityQuery, CurrentUserSpecialityQueryVariables>(
        Operations.CurrentUserSpeciality,
        options
    );
}
export function useCurrentUserSpecialitySuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              CurrentUserSpecialityQuery,
              CurrentUserSpecialityQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<CurrentUserSpecialityQuery, CurrentUserSpecialityQueryVariables>(
        Operations.CurrentUserSpeciality,
        options
    );
}
export type CurrentUserSpecialityQueryHookResult = ReturnType<typeof useCurrentUserSpecialityQuery>;
export type CurrentUserSpecialityLazyQueryHookResult = ReturnType<
    typeof useCurrentUserSpecialityLazyQuery
>;
export type CurrentUserSpecialitySuspenseQueryHookResult = ReturnType<
    typeof useCurrentUserSpecialitySuspenseQuery
>;
export type CurrentUserSpecialityQueryResult = Apollo.QueryResult<
    CurrentUserSpecialityQuery,
    CurrentUserSpecialityQueryVariables
>;

/**
 * __useTopicsForSelectorQuery__
 *
 * To run a query within a React component, call `useTopicsForSelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicsForSelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicsForSelectorQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopicsForSelectorQuery(
    baseOptions?: Apollo.QueryHookOptions<TopicsForSelectorQuery, TopicsForSelectorQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<TopicsForSelectorQuery, TopicsForSelectorQueryVariables>(
        Operations.TopicsForSelector,
        options
    );
}
export function useTopicsForSelectorLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        TopicsForSelectorQuery,
        TopicsForSelectorQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<TopicsForSelectorQuery, TopicsForSelectorQueryVariables>(
        Operations.TopicsForSelector,
        options
    );
}
export function useTopicsForSelectorSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<TopicsForSelectorQuery, TopicsForSelectorQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<TopicsForSelectorQuery, TopicsForSelectorQueryVariables>(
        Operations.TopicsForSelector,
        options
    );
}
export type TopicsForSelectorQueryHookResult = ReturnType<typeof useTopicsForSelectorQuery>;
export type TopicsForSelectorLazyQueryHookResult = ReturnType<typeof useTopicsForSelectorLazyQuery>;
export type TopicsForSelectorSuspenseQueryHookResult = ReturnType<
    typeof useTopicsForSelectorSuspenseQuery
>;
export type TopicsForSelectorQueryResult = Apollo.QueryResult<
    TopicsForSelectorQuery,
    TopicsForSelectorQueryVariables
>;

/**
 * __useAllGuidelinesForGuidelinesPageQuery__
 *
 * To run a query within a React component, call `useAllGuidelinesForGuidelinesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGuidelinesForGuidelinesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGuidelinesForGuidelinesPageQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useAllGuidelinesForGuidelinesPageQuery(
    baseOptions: Apollo.QueryHookOptions<
        AllGuidelinesForGuidelinesPageQuery,
        AllGuidelinesForGuidelinesPageQueryVariables
    > &
        (
            | { variables: AllGuidelinesForGuidelinesPageQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        AllGuidelinesForGuidelinesPageQuery,
        AllGuidelinesForGuidelinesPageQueryVariables
    >(Operations.AllGuidelinesForGuidelinesPage, options);
}
export function useAllGuidelinesForGuidelinesPageLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        AllGuidelinesForGuidelinesPageQuery,
        AllGuidelinesForGuidelinesPageQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        AllGuidelinesForGuidelinesPageQuery,
        AllGuidelinesForGuidelinesPageQueryVariables
    >(Operations.AllGuidelinesForGuidelinesPage, options);
}
export function useAllGuidelinesForGuidelinesPageSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              AllGuidelinesForGuidelinesPageQuery,
              AllGuidelinesForGuidelinesPageQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        AllGuidelinesForGuidelinesPageQuery,
        AllGuidelinesForGuidelinesPageQueryVariables
    >(Operations.AllGuidelinesForGuidelinesPage, options);
}
export type AllGuidelinesForGuidelinesPageQueryHookResult = ReturnType<
    typeof useAllGuidelinesForGuidelinesPageQuery
>;
export type AllGuidelinesForGuidelinesPageLazyQueryHookResult = ReturnType<
    typeof useAllGuidelinesForGuidelinesPageLazyQuery
>;
export type AllGuidelinesForGuidelinesPageSuspenseQueryHookResult = ReturnType<
    typeof useAllGuidelinesForGuidelinesPageSuspenseQuery
>;
export type AllGuidelinesForGuidelinesPageQueryResult = Apollo.QueryResult<
    AllGuidelinesForGuidelinesPageQuery,
    AllGuidelinesForGuidelinesPageQueryVariables
>;

/**
 * __useSearchForTopicsQuery__
 *
 * To run a query within a React component, call `useSearchForTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForTopicsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSearchForTopicsQuery(
    baseOptions: Apollo.QueryHookOptions<SearchForTopicsQuery, SearchForTopicsQueryVariables> &
        ({ variables: SearchForTopicsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SearchForTopicsQuery, SearchForTopicsQueryVariables>(
        Operations.SearchForTopics,
        options
    );
}
export function useSearchForTopicsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SearchForTopicsQuery, SearchForTopicsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SearchForTopicsQuery, SearchForTopicsQueryVariables>(
        Operations.SearchForTopics,
        options
    );
}
export function useSearchForTopicsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<SearchForTopicsQuery, SearchForTopicsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<SearchForTopicsQuery, SearchForTopicsQueryVariables>(
        Operations.SearchForTopics,
        options
    );
}
export type SearchForTopicsQueryHookResult = ReturnType<typeof useSearchForTopicsQuery>;
export type SearchForTopicsLazyQueryHookResult = ReturnType<typeof useSearchForTopicsLazyQuery>;
export type SearchForTopicsSuspenseQueryHookResult = ReturnType<
    typeof useSearchForTopicsSuspenseQuery
>;
export type SearchForTopicsQueryResult = Apollo.QueryResult<
    SearchForTopicsQuery,
    SearchForTopicsQueryVariables
>;

/**
 * __useContentDocumentsSimplifiedQuery__
 *
 * To run a query within a React component, call `useContentDocumentsSimplifiedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDocumentsSimplifiedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDocumentsSimplifiedQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useContentDocumentsSimplifiedQuery(
    baseOptions: Apollo.QueryHookOptions<
        ContentDocumentsSimplifiedQuery,
        ContentDocumentsSimplifiedQueryVariables
    > &
        (
            | { variables: ContentDocumentsSimplifiedQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        ContentDocumentsSimplifiedQuery,
        ContentDocumentsSimplifiedQueryVariables
    >(Operations.ContentDocumentsSimplified, options);
}
export function useContentDocumentsSimplifiedLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ContentDocumentsSimplifiedQuery,
        ContentDocumentsSimplifiedQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        ContentDocumentsSimplifiedQuery,
        ContentDocumentsSimplifiedQueryVariables
    >(Operations.ContentDocumentsSimplified, options);
}
export function useContentDocumentsSimplifiedSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              ContentDocumentsSimplifiedQuery,
              ContentDocumentsSimplifiedQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        ContentDocumentsSimplifiedQuery,
        ContentDocumentsSimplifiedQueryVariables
    >(Operations.ContentDocumentsSimplified, options);
}
export type ContentDocumentsSimplifiedQueryHookResult = ReturnType<
    typeof useContentDocumentsSimplifiedQuery
>;
export type ContentDocumentsSimplifiedLazyQueryHookResult = ReturnType<
    typeof useContentDocumentsSimplifiedLazyQuery
>;
export type ContentDocumentsSimplifiedSuspenseQueryHookResult = ReturnType<
    typeof useContentDocumentsSimplifiedSuspenseQuery
>;
export type ContentDocumentsSimplifiedQueryResult = Apollo.QueryResult<
    ContentDocumentsSimplifiedQuery,
    ContentDocumentsSimplifiedQueryVariables
>;

/**
 * __useContentDocumentsQuery__
 *
 * To run a query within a React component, call `useContentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDocumentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useContentDocumentsQuery(
    baseOptions: Apollo.QueryHookOptions<ContentDocumentsQuery, ContentDocumentsQueryVariables> &
        ({ variables: ContentDocumentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ContentDocumentsQuery, ContentDocumentsQueryVariables>(
        Operations.ContentDocuments,
        options
    );
}
export function useContentDocumentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ContentDocumentsQuery, ContentDocumentsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ContentDocumentsQuery, ContentDocumentsQueryVariables>(
        Operations.ContentDocuments,
        options
    );
}
export function useContentDocumentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<ContentDocumentsQuery, ContentDocumentsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<ContentDocumentsQuery, ContentDocumentsQueryVariables>(
        Operations.ContentDocuments,
        options
    );
}
export type ContentDocumentsQueryHookResult = ReturnType<typeof useContentDocumentsQuery>;
export type ContentDocumentsLazyQueryHookResult = ReturnType<typeof useContentDocumentsLazyQuery>;
export type ContentDocumentsSuspenseQueryHookResult = ReturnType<
    typeof useContentDocumentsSuspenseQuery
>;
export type ContentDocumentsQueryResult = Apollo.QueryResult<
    ContentDocumentsQuery,
    ContentDocumentsQueryVariables
>;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useProductsQuery(
    baseOptions: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables> &
        ({ variables: ProductsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(Operations.Products, options);
}
export function useProductsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(Operations.Products, options);
}
export function useProductsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<ProductsQuery, ProductsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(
        Operations.Products,
        options
    );
}
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsSuspenseQueryHookResult = ReturnType<typeof useProductsSuspenseQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;

/**
 * __useContentsQuery__
 *
 * To run a query within a React component, call `useContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useContentsQuery(
    baseOptions: Apollo.QueryHookOptions<ContentsQuery, ContentsQueryVariables> &
        ({ variables: ContentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ContentsQuery, ContentsQueryVariables>(Operations.Contents, options);
}
export function useContentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ContentsQuery, ContentsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<ContentsQuery, ContentsQueryVariables>(Operations.Contents, options);
}
export function useContentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<ContentsQuery, ContentsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<ContentsQuery, ContentsQueryVariables>(
        Operations.Contents,
        options
    );
}
export type ContentsQueryHookResult = ReturnType<typeof useContentsQuery>;
export type ContentsLazyQueryHookResult = ReturnType<typeof useContentsLazyQuery>;
export type ContentsSuspenseQueryHookResult = ReturnType<typeof useContentsSuspenseQuery>;
export type ContentsQueryResult = Apollo.QueryResult<ContentsQuery, ContentsQueryVariables>;

/**
 * __useVerifyContentExistsQuery__
 *
 * To run a query within a React component, call `useVerifyContentExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyContentExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyContentExistsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useVerifyContentExistsQuery(
    baseOptions: Apollo.QueryHookOptions<
        VerifyContentExistsQuery,
        VerifyContentExistsQueryVariables
    > &
        ({ variables: VerifyContentExistsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<VerifyContentExistsQuery, VerifyContentExistsQueryVariables>(
        Operations.VerifyContentExists,
        options
    );
}
export function useVerifyContentExistsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        VerifyContentExistsQuery,
        VerifyContentExistsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<VerifyContentExistsQuery, VerifyContentExistsQueryVariables>(
        Operations.VerifyContentExists,
        options
    );
}
export function useVerifyContentExistsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              VerifyContentExistsQuery,
              VerifyContentExistsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<VerifyContentExistsQuery, VerifyContentExistsQueryVariables>(
        Operations.VerifyContentExists,
        options
    );
}
export type VerifyContentExistsQueryHookResult = ReturnType<typeof useVerifyContentExistsQuery>;
export type VerifyContentExistsLazyQueryHookResult = ReturnType<
    typeof useVerifyContentExistsLazyQuery
>;
export type VerifyContentExistsSuspenseQueryHookResult = ReturnType<
    typeof useVerifyContentExistsSuspenseQuery
>;
export type VerifyContentExistsQueryResult = Apollo.QueryResult<
    VerifyContentExistsQuery,
    VerifyContentExistsQueryVariables
>;

/**
 * __usePartnerDocumentsQuery__
 *
 * To run a query within a React component, call `usePartnerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDocumentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePartnerDocumentsQuery(
    baseOptions: Apollo.QueryHookOptions<PartnerDocumentsQuery, PartnerDocumentsQueryVariables> &
        ({ variables: PartnerDocumentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<PartnerDocumentsQuery, PartnerDocumentsQueryVariables>(
        Operations.PartnerDocuments,
        options
    );
}
export function usePartnerDocumentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<PartnerDocumentsQuery, PartnerDocumentsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<PartnerDocumentsQuery, PartnerDocumentsQueryVariables>(
        Operations.PartnerDocuments,
        options
    );
}
export function usePartnerDocumentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<PartnerDocumentsQuery, PartnerDocumentsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<PartnerDocumentsQuery, PartnerDocumentsQueryVariables>(
        Operations.PartnerDocuments,
        options
    );
}
export type PartnerDocumentsQueryHookResult = ReturnType<typeof usePartnerDocumentsQuery>;
export type PartnerDocumentsLazyQueryHookResult = ReturnType<typeof usePartnerDocumentsLazyQuery>;
export type PartnerDocumentsSuspenseQueryHookResult = ReturnType<
    typeof usePartnerDocumentsSuspenseQuery
>;
export type PartnerDocumentsQueryResult = Apollo.QueryResult<
    PartnerDocumentsQuery,
    PartnerDocumentsQueryVariables
>;

/**
 * __useSponsorshipsV2Query__
 *
 * To run a query within a React component, call `useSponsorshipsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useSponsorshipsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorshipsV2Query({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSponsorshipsV2Query(
    baseOptions?: Apollo.QueryHookOptions<SponsorshipsV2Query, SponsorshipsV2QueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SponsorshipsV2Query, SponsorshipsV2QueryVariables>(
        Operations.SponsorshipsV2,
        options
    );
}
export function useSponsorshipsV2LazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SponsorshipsV2Query, SponsorshipsV2QueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SponsorshipsV2Query, SponsorshipsV2QueryVariables>(
        Operations.SponsorshipsV2,
        options
    );
}
export function useSponsorshipsV2SuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<SponsorshipsV2Query, SponsorshipsV2QueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<SponsorshipsV2Query, SponsorshipsV2QueryVariables>(
        Operations.SponsorshipsV2,
        options
    );
}
export type SponsorshipsV2QueryHookResult = ReturnType<typeof useSponsorshipsV2Query>;
export type SponsorshipsV2LazyQueryHookResult = ReturnType<typeof useSponsorshipsV2LazyQuery>;
export type SponsorshipsV2SuspenseQueryHookResult = ReturnType<
    typeof useSponsorshipsV2SuspenseQuery
>;
export type SponsorshipsV2QueryResult = Apollo.QueryResult<
    SponsorshipsV2Query,
    SponsorshipsV2QueryVariables
>;

/**
 * __useSponsorshipsListQuery__
 *
 * To run a query within a React component, call `useSponsorshipsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSponsorshipsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSponsorshipsListQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSponsorshipsListQuery(
    baseOptions?: Apollo.QueryHookOptions<SponsorshipsListQuery, SponsorshipsListQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SponsorshipsListQuery, SponsorshipsListQueryVariables>(
        Operations.SponsorshipsList,
        options
    );
}
export function useSponsorshipsListLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SponsorshipsListQuery, SponsorshipsListQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SponsorshipsListQuery, SponsorshipsListQueryVariables>(
        Operations.SponsorshipsList,
        options
    );
}
export function useSponsorshipsListSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<SponsorshipsListQuery, SponsorshipsListQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<SponsorshipsListQuery, SponsorshipsListQueryVariables>(
        Operations.SponsorshipsList,
        options
    );
}
export type SponsorshipsListQueryHookResult = ReturnType<typeof useSponsorshipsListQuery>;
export type SponsorshipsListLazyQueryHookResult = ReturnType<typeof useSponsorshipsListLazyQuery>;
export type SponsorshipsListSuspenseQueryHookResult = ReturnType<
    typeof useSponsorshipsListSuspenseQuery
>;
export type SponsorshipsListQueryResult = Apollo.QueryResult<
    SponsorshipsListQuery,
    SponsorshipsListQueryVariables
>;

/**
 * __usePartnerCompaniesQuery__
 *
 * To run a query within a React component, call `usePartnerCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCompaniesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePartnerCompaniesQuery(
    baseOptions: Apollo.QueryHookOptions<PartnerCompaniesQuery, PartnerCompaniesQueryVariables> &
        ({ variables: PartnerCompaniesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<PartnerCompaniesQuery, PartnerCompaniesQueryVariables>(
        Operations.PartnerCompanies,
        options
    );
}
export function usePartnerCompaniesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<PartnerCompaniesQuery, PartnerCompaniesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<PartnerCompaniesQuery, PartnerCompaniesQueryVariables>(
        Operations.PartnerCompanies,
        options
    );
}
export function usePartnerCompaniesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<PartnerCompaniesQuery, PartnerCompaniesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<PartnerCompaniesQuery, PartnerCompaniesQueryVariables>(
        Operations.PartnerCompanies,
        options
    );
}
export type PartnerCompaniesQueryHookResult = ReturnType<typeof usePartnerCompaniesQuery>;
export type PartnerCompaniesLazyQueryHookResult = ReturnType<typeof usePartnerCompaniesLazyQuery>;
export type PartnerCompaniesSuspenseQueryHookResult = ReturnType<
    typeof usePartnerCompaniesSuspenseQuery
>;
export type PartnerCompaniesQueryResult = Apollo.QueryResult<
    PartnerCompaniesQuery,
    PartnerCompaniesQueryVariables
>;

/**
 * __usePartnerCompaniesWithDepartmentsQuery__
 *
 * To run a query within a React component, call `usePartnerCompaniesWithDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCompaniesWithDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCompaniesWithDepartmentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePartnerCompaniesWithDepartmentsQuery(
    baseOptions: Apollo.QueryHookOptions<
        PartnerCompaniesWithDepartmentsQuery,
        PartnerCompaniesWithDepartmentsQueryVariables
    > &
        (
            | { variables: PartnerCompaniesWithDepartmentsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        PartnerCompaniesWithDepartmentsQuery,
        PartnerCompaniesWithDepartmentsQueryVariables
    >(Operations.PartnerCompaniesWithDepartments, options);
}
export function usePartnerCompaniesWithDepartmentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PartnerCompaniesWithDepartmentsQuery,
        PartnerCompaniesWithDepartmentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        PartnerCompaniesWithDepartmentsQuery,
        PartnerCompaniesWithDepartmentsQueryVariables
    >(Operations.PartnerCompaniesWithDepartments, options);
}
export function usePartnerCompaniesWithDepartmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              PartnerCompaniesWithDepartmentsQuery,
              PartnerCompaniesWithDepartmentsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        PartnerCompaniesWithDepartmentsQuery,
        PartnerCompaniesWithDepartmentsQueryVariables
    >(Operations.PartnerCompaniesWithDepartments, options);
}
export type PartnerCompaniesWithDepartmentsQueryHookResult = ReturnType<
    typeof usePartnerCompaniesWithDepartmentsQuery
>;
export type PartnerCompaniesWithDepartmentsLazyQueryHookResult = ReturnType<
    typeof usePartnerCompaniesWithDepartmentsLazyQuery
>;
export type PartnerCompaniesWithDepartmentsSuspenseQueryHookResult = ReturnType<
    typeof usePartnerCompaniesWithDepartmentsSuspenseQuery
>;
export type PartnerCompaniesWithDepartmentsQueryResult = Apollo.QueryResult<
    PartnerCompaniesWithDepartmentsQuery,
    PartnerCompaniesWithDepartmentsQueryVariables
>;

/**
 * __useMediathekVideosQuery__
 *
 * To run a query within a React component, call `useMediathekVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediathekVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediathekVideosQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useMediathekVideosQuery(
    baseOptions: Apollo.QueryHookOptions<MediathekVideosQuery, MediathekVideosQueryVariables> &
        ({ variables: MediathekVideosQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<MediathekVideosQuery, MediathekVideosQueryVariables>(
        Operations.MediathekVideos,
        options
    );
}
export function useMediathekVideosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<MediathekVideosQuery, MediathekVideosQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<MediathekVideosQuery, MediathekVideosQueryVariables>(
        Operations.MediathekVideos,
        options
    );
}
export function useMediathekVideosSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<MediathekVideosQuery, MediathekVideosQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<MediathekVideosQuery, MediathekVideosQueryVariables>(
        Operations.MediathekVideos,
        options
    );
}
export type MediathekVideosQueryHookResult = ReturnType<typeof useMediathekVideosQuery>;
export type MediathekVideosLazyQueryHookResult = ReturnType<typeof useMediathekVideosLazyQuery>;
export type MediathekVideosSuspenseQueryHookResult = ReturnType<
    typeof useMediathekVideosSuspenseQuery
>;
export type MediathekVideosQueryResult = Apollo.QueryResult<
    MediathekVideosQuery,
    MediathekVideosQueryVariables
>;

/**
 * __useMediathekPartnerforumContentsQuery__
 *
 * To run a query within a React component, call `useMediathekPartnerforumContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediathekPartnerforumContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediathekPartnerforumContentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useMediathekPartnerforumContentsQuery(
    baseOptions: Apollo.QueryHookOptions<
        MediathekPartnerforumContentsQuery,
        MediathekPartnerforumContentsQueryVariables
    > &
        (
            | { variables: MediathekPartnerforumContentsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        MediathekPartnerforumContentsQuery,
        MediathekPartnerforumContentsQueryVariables
    >(Operations.MediathekPartnerforumContents, options);
}
export function useMediathekPartnerforumContentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        MediathekPartnerforumContentsQuery,
        MediathekPartnerforumContentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        MediathekPartnerforumContentsQuery,
        MediathekPartnerforumContentsQueryVariables
    >(Operations.MediathekPartnerforumContents, options);
}
export function useMediathekPartnerforumContentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              MediathekPartnerforumContentsQuery,
              MediathekPartnerforumContentsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        MediathekPartnerforumContentsQuery,
        MediathekPartnerforumContentsQueryVariables
    >(Operations.MediathekPartnerforumContents, options);
}
export type MediathekPartnerforumContentsQueryHookResult = ReturnType<
    typeof useMediathekPartnerforumContentsQuery
>;
export type MediathekPartnerforumContentsLazyQueryHookResult = ReturnType<
    typeof useMediathekPartnerforumContentsLazyQuery
>;
export type MediathekPartnerforumContentsSuspenseQueryHookResult = ReturnType<
    typeof useMediathekPartnerforumContentsSuspenseQuery
>;
export type MediathekPartnerforumContentsQueryResult = Apollo.QueryResult<
    MediathekPartnerforumContentsQuery,
    MediathekPartnerforumContentsQueryVariables
>;

/**
 * __useFeaturedCoursesQuery__
 *
 * To run a query within a React component, call `useFeaturedCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useFeaturedCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<FeaturedCoursesQuery, FeaturedCoursesQueryVariables> &
        ({ variables: FeaturedCoursesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<FeaturedCoursesQuery, FeaturedCoursesQueryVariables>(
        Operations.FeaturedCourses,
        options
    );
}
export function useFeaturedCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<FeaturedCoursesQuery, FeaturedCoursesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<FeaturedCoursesQuery, FeaturedCoursesQueryVariables>(
        Operations.FeaturedCourses,
        options
    );
}
export function useFeaturedCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<FeaturedCoursesQuery, FeaturedCoursesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<FeaturedCoursesQuery, FeaturedCoursesQueryVariables>(
        Operations.FeaturedCourses,
        options
    );
}
export type FeaturedCoursesQueryHookResult = ReturnType<typeof useFeaturedCoursesQuery>;
export type FeaturedCoursesLazyQueryHookResult = ReturnType<typeof useFeaturedCoursesLazyQuery>;
export type FeaturedCoursesSuspenseQueryHookResult = ReturnType<
    typeof useFeaturedCoursesSuspenseQuery
>;
export type FeaturedCoursesQueryResult = Apollo.QueryResult<
    FeaturedCoursesQuery,
    FeaturedCoursesQueryVariables
>;

/**
 * __useGetCompanyPageSlugQuery__
 *
 * To run a query within a React component, call `useGetCompanyPageSlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyPageSlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyPageSlugQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyPageSlugQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetCompanyPageSlugQuery,
        GetCompanyPageSlugQueryVariables
    > &
        ({ variables: GetCompanyPageSlugQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCompanyPageSlugQuery, GetCompanyPageSlugQueryVariables>(
        Operations.GetCompanyPageSlug,
        options
    );
}
export function useGetCompanyPageSlugLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCompanyPageSlugQuery,
        GetCompanyPageSlugQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetCompanyPageSlugQuery, GetCompanyPageSlugQueryVariables>(
        Operations.GetCompanyPageSlug,
        options
    );
}
export function useGetCompanyPageSlugSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetCompanyPageSlugQuery, GetCompanyPageSlugQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetCompanyPageSlugQuery, GetCompanyPageSlugQueryVariables>(
        Operations.GetCompanyPageSlug,
        options
    );
}
export type GetCompanyPageSlugQueryHookResult = ReturnType<typeof useGetCompanyPageSlugQuery>;
export type GetCompanyPageSlugLazyQueryHookResult = ReturnType<
    typeof useGetCompanyPageSlugLazyQuery
>;
export type GetCompanyPageSlugSuspenseQueryHookResult = ReturnType<
    typeof useGetCompanyPageSlugSuspenseQuery
>;
export type GetCompanyPageSlugQueryResult = Apollo.QueryResult<
    GetCompanyPageSlugQuery,
    GetCompanyPageSlugQueryVariables
>;

/**
 * __useGetCompanyDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetCompanyDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDepartmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyDepartmentsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetCompanyDepartmentsQuery,
        GetCompanyDepartmentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>(
        Operations.GetCompanyDepartments,
        options
    );
}
export function useGetCompanyDepartmentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCompanyDepartmentsQuery,
        GetCompanyDepartmentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>(
        Operations.GetCompanyDepartments,
        options
    );
}
export function useGetCompanyDepartmentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCompanyDepartmentsQuery,
              GetCompanyDepartmentsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetCompanyDepartmentsQuery, GetCompanyDepartmentsQueryVariables>(
        Operations.GetCompanyDepartments,
        options
    );
}
export type GetCompanyDepartmentsQueryHookResult = ReturnType<typeof useGetCompanyDepartmentsQuery>;
export type GetCompanyDepartmentsLazyQueryHookResult = ReturnType<
    typeof useGetCompanyDepartmentsLazyQuery
>;
export type GetCompanyDepartmentsSuspenseQueryHookResult = ReturnType<
    typeof useGetCompanyDepartmentsSuspenseQuery
>;
export type GetCompanyDepartmentsQueryResult = Apollo.QueryResult<
    GetCompanyDepartmentsQuery,
    GetCompanyDepartmentsQueryVariables
>;

/**
 * __useGetBookingsForHistoryPageMyFomfQuery__
 *
 * To run a query within a React component, call `useGetBookingsForHistoryPageMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsForHistoryPageMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsForHistoryPageMyFomfQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetBookingsForHistoryPageMyFomfQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBookingsForHistoryPageMyFomfQuery,
        GetBookingsForHistoryPageMyFomfQueryVariables
    > &
        (
            | { variables: GetBookingsForHistoryPageMyFomfQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBookingsForHistoryPageMyFomfQuery,
        GetBookingsForHistoryPageMyFomfQueryVariables
    >(Operations.GetBookingsForHistoryPageMyFomf, options);
}
export function useGetBookingsForHistoryPageMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBookingsForHistoryPageMyFomfQuery,
        GetBookingsForHistoryPageMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBookingsForHistoryPageMyFomfQuery,
        GetBookingsForHistoryPageMyFomfQueryVariables
    >(Operations.GetBookingsForHistoryPageMyFomf, options);
}
export function useGetBookingsForHistoryPageMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBookingsForHistoryPageMyFomfQuery,
              GetBookingsForHistoryPageMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBookingsForHistoryPageMyFomfQuery,
        GetBookingsForHistoryPageMyFomfQueryVariables
    >(Operations.GetBookingsForHistoryPageMyFomf, options);
}
export type GetBookingsForHistoryPageMyFomfQueryHookResult = ReturnType<
    typeof useGetBookingsForHistoryPageMyFomfQuery
>;
export type GetBookingsForHistoryPageMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetBookingsForHistoryPageMyFomfLazyQuery
>;
export type GetBookingsForHistoryPageMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetBookingsForHistoryPageMyFomfSuspenseQuery
>;
export type GetBookingsForHistoryPageMyFomfQueryResult = Apollo.QueryResult<
    GetBookingsForHistoryPageMyFomfQuery,
    GetBookingsForHistoryPageMyFomfQueryVariables
>;

/**
 * __useGetBookingsForLatestPageMyFomfQuery__
 *
 * To run a query within a React component, call `useGetBookingsForLatestPageMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingsForLatestPageMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingsForLatestPageMyFomfQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetBookingsForLatestPageMyFomfQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetBookingsForLatestPageMyFomfQuery,
        GetBookingsForLatestPageMyFomfQueryVariables
    > &
        (
            | { variables: GetBookingsForLatestPageMyFomfQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBookingsForLatestPageMyFomfQuery,
        GetBookingsForLatestPageMyFomfQueryVariables
    >(Operations.GetBookingsForLatestPageMyFomf, options);
}
export function useGetBookingsForLatestPageMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBookingsForLatestPageMyFomfQuery,
        GetBookingsForLatestPageMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBookingsForLatestPageMyFomfQuery,
        GetBookingsForLatestPageMyFomfQueryVariables
    >(Operations.GetBookingsForLatestPageMyFomf, options);
}
export function useGetBookingsForLatestPageMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBookingsForLatestPageMyFomfQuery,
              GetBookingsForLatestPageMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBookingsForLatestPageMyFomfQuery,
        GetBookingsForLatestPageMyFomfQueryVariables
    >(Operations.GetBookingsForLatestPageMyFomf, options);
}
export type GetBookingsForLatestPageMyFomfQueryHookResult = ReturnType<
    typeof useGetBookingsForLatestPageMyFomfQuery
>;
export type GetBookingsForLatestPageMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetBookingsForLatestPageMyFomfLazyQuery
>;
export type GetBookingsForLatestPageMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetBookingsForLatestPageMyFomfSuspenseQuery
>;
export type GetBookingsForLatestPageMyFomfQueryResult = Apollo.QueryResult<
    GetBookingsForLatestPageMyFomfQuery,
    GetBookingsForLatestPageMyFomfQueryVariables
>;

/**
 * __useGetStartedSystematicCoursesForMyFomfQuery__
 *
 * To run a query within a React component, call `useGetStartedSystematicCoursesForMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStartedSystematicCoursesForMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStartedSystematicCoursesForMyFomfQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      brandType: // value for 'brandType'
 *      country: // value for 'country'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useGetStartedSystematicCoursesForMyFomfQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetStartedSystematicCoursesForMyFomfQuery,
        GetStartedSystematicCoursesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetStartedSystematicCoursesForMyFomfQuery,
        GetStartedSystematicCoursesForMyFomfQueryVariables
    >(Operations.GetStartedSystematicCoursesForMyFomf, options);
}
export function useGetStartedSystematicCoursesForMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetStartedSystematicCoursesForMyFomfQuery,
        GetStartedSystematicCoursesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetStartedSystematicCoursesForMyFomfQuery,
        GetStartedSystematicCoursesForMyFomfQueryVariables
    >(Operations.GetStartedSystematicCoursesForMyFomf, options);
}
export function useGetStartedSystematicCoursesForMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetStartedSystematicCoursesForMyFomfQuery,
              GetStartedSystematicCoursesForMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetStartedSystematicCoursesForMyFomfQuery,
        GetStartedSystematicCoursesForMyFomfQueryVariables
    >(Operations.GetStartedSystematicCoursesForMyFomf, options);
}
export type GetStartedSystematicCoursesForMyFomfQueryHookResult = ReturnType<
    typeof useGetStartedSystematicCoursesForMyFomfQuery
>;
export type GetStartedSystematicCoursesForMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetStartedSystematicCoursesForMyFomfLazyQuery
>;
export type GetStartedSystematicCoursesForMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetStartedSystematicCoursesForMyFomfSuspenseQuery
>;
export type GetStartedSystematicCoursesForMyFomfQueryResult = Apollo.QueryResult<
    GetStartedSystematicCoursesForMyFomfQuery,
    GetStartedSystematicCoursesForMyFomfQueryVariables
>;

/**
 * __useGetOnDemandCoursesForMyFomfQuery__
 *
 * To run a query within a React component, call `useGetOnDemandCoursesForMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnDemandCoursesForMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnDemandCoursesForMyFomfQuery({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      brandType: // value for 'brandType'
 *      country: // value for 'country'
 *      completed: // value for 'completed'
 *   },
 * });
 */
export function useGetOnDemandCoursesForMyFomfQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetOnDemandCoursesForMyFomfQuery,
        GetOnDemandCoursesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOnDemandCoursesForMyFomfQuery,
        GetOnDemandCoursesForMyFomfQueryVariables
    >(Operations.GetOnDemandCoursesForMyFomf, options);
}
export function useGetOnDemandCoursesForMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOnDemandCoursesForMyFomfQuery,
        GetOnDemandCoursesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOnDemandCoursesForMyFomfQuery,
        GetOnDemandCoursesForMyFomfQueryVariables
    >(Operations.GetOnDemandCoursesForMyFomf, options);
}
export function useGetOnDemandCoursesForMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOnDemandCoursesForMyFomfQuery,
              GetOnDemandCoursesForMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOnDemandCoursesForMyFomfQuery,
        GetOnDemandCoursesForMyFomfQueryVariables
    >(Operations.GetOnDemandCoursesForMyFomf, options);
}
export type GetOnDemandCoursesForMyFomfQueryHookResult = ReturnType<
    typeof useGetOnDemandCoursesForMyFomfQuery
>;
export type GetOnDemandCoursesForMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetOnDemandCoursesForMyFomfLazyQuery
>;
export type GetOnDemandCoursesForMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetOnDemandCoursesForMyFomfSuspenseQuery
>;
export type GetOnDemandCoursesForMyFomfQueryResult = Apollo.QueryResult<
    GetOnDemandCoursesForMyFomfQuery,
    GetOnDemandCoursesForMyFomfQueryVariables
>;

/**
 * __useGetStartedVideosForMyFomfQuery__
 *
 * To run a query within a React component, call `useGetStartedVideosForMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStartedVideosForMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStartedVideosForMyFomfQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetStartedVideosForMyFomfQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetStartedVideosForMyFomfQuery,
        GetStartedVideosForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetStartedVideosForMyFomfQuery, GetStartedVideosForMyFomfQueryVariables>(
        Operations.GetStartedVideosForMyFOMF,
        options
    );
}
export function useGetStartedVideosForMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetStartedVideosForMyFomfQuery,
        GetStartedVideosForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetStartedVideosForMyFomfQuery,
        GetStartedVideosForMyFomfQueryVariables
    >(Operations.GetStartedVideosForMyFOMF, options);
}
export function useGetStartedVideosForMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetStartedVideosForMyFomfQuery,
              GetStartedVideosForMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetStartedVideosForMyFomfQuery,
        GetStartedVideosForMyFomfQueryVariables
    >(Operations.GetStartedVideosForMyFOMF, options);
}
export type GetStartedVideosForMyFomfQueryHookResult = ReturnType<
    typeof useGetStartedVideosForMyFomfQuery
>;
export type GetStartedVideosForMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetStartedVideosForMyFomfLazyQuery
>;
export type GetStartedVideosForMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetStartedVideosForMyFomfSuspenseQuery
>;
export type GetStartedVideosForMyFomfQueryResult = Apollo.QueryResult<
    GetStartedVideosForMyFomfQuery,
    GetStartedVideosForMyFomfQueryVariables
>;

/**
 * __useGetBookmarkedGuidelinesForMyFomfQuery__
 *
 * To run a query within a React component, call `useGetBookmarkedGuidelinesForMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkedGuidelinesForMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkedGuidelinesForMyFomfQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetBookmarkedGuidelinesForMyFomfQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetBookmarkedGuidelinesForMyFomfQuery,
        GetBookmarkedGuidelinesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBookmarkedGuidelinesForMyFomfQuery,
        GetBookmarkedGuidelinesForMyFomfQueryVariables
    >(Operations.GetBookmarkedGuidelinesForMyFOMF, options);
}
export function useGetBookmarkedGuidelinesForMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBookmarkedGuidelinesForMyFomfQuery,
        GetBookmarkedGuidelinesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBookmarkedGuidelinesForMyFomfQuery,
        GetBookmarkedGuidelinesForMyFomfQueryVariables
    >(Operations.GetBookmarkedGuidelinesForMyFOMF, options);
}
export function useGetBookmarkedGuidelinesForMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBookmarkedGuidelinesForMyFomfQuery,
              GetBookmarkedGuidelinesForMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBookmarkedGuidelinesForMyFomfQuery,
        GetBookmarkedGuidelinesForMyFomfQueryVariables
    >(Operations.GetBookmarkedGuidelinesForMyFOMF, options);
}
export type GetBookmarkedGuidelinesForMyFomfQueryHookResult = ReturnType<
    typeof useGetBookmarkedGuidelinesForMyFomfQuery
>;
export type GetBookmarkedGuidelinesForMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetBookmarkedGuidelinesForMyFomfLazyQuery
>;
export type GetBookmarkedGuidelinesForMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetBookmarkedGuidelinesForMyFomfSuspenseQuery
>;
export type GetBookmarkedGuidelinesForMyFomfQueryResult = Apollo.QueryResult<
    GetBookmarkedGuidelinesForMyFomfQuery,
    GetBookmarkedGuidelinesForMyFomfQueryVariables
>;

/**
 * __useGetBookmarkedContentsForMyFomfQuery__
 *
 * To run a query within a React component, call `useGetBookmarkedContentsForMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkedContentsForMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkedContentsForMyFomfQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetBookmarkedContentsForMyFomfQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetBookmarkedContentsForMyFomfQuery,
        GetBookmarkedContentsForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBookmarkedContentsForMyFomfQuery,
        GetBookmarkedContentsForMyFomfQueryVariables
    >(Operations.GetBookmarkedContentsForMyFOMF, options);
}
export function useGetBookmarkedContentsForMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBookmarkedContentsForMyFomfQuery,
        GetBookmarkedContentsForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBookmarkedContentsForMyFomfQuery,
        GetBookmarkedContentsForMyFomfQueryVariables
    >(Operations.GetBookmarkedContentsForMyFOMF, options);
}
export function useGetBookmarkedContentsForMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBookmarkedContentsForMyFomfQuery,
              GetBookmarkedContentsForMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBookmarkedContentsForMyFomfQuery,
        GetBookmarkedContentsForMyFomfQueryVariables
    >(Operations.GetBookmarkedContentsForMyFOMF, options);
}
export type GetBookmarkedContentsForMyFomfQueryHookResult = ReturnType<
    typeof useGetBookmarkedContentsForMyFomfQuery
>;
export type GetBookmarkedContentsForMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetBookmarkedContentsForMyFomfLazyQuery
>;
export type GetBookmarkedContentsForMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetBookmarkedContentsForMyFomfSuspenseQuery
>;
export type GetBookmarkedContentsForMyFomfQueryResult = Apollo.QueryResult<
    GetBookmarkedContentsForMyFomfQuery,
    GetBookmarkedContentsForMyFomfQueryVariables
>;

/**
 * __useGetBookmarkedCoursesForMyFomfQuery__
 *
 * To run a query within a React component, call `useGetBookmarkedCoursesForMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkedCoursesForMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkedCoursesForMyFomfQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetBookmarkedCoursesForMyFomfQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetBookmarkedCoursesForMyFomfQuery,
        GetBookmarkedCoursesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBookmarkedCoursesForMyFomfQuery,
        GetBookmarkedCoursesForMyFomfQueryVariables
    >(Operations.GetBookmarkedCoursesForMyFOMF, options);
}
export function useGetBookmarkedCoursesForMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBookmarkedCoursesForMyFomfQuery,
        GetBookmarkedCoursesForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBookmarkedCoursesForMyFomfQuery,
        GetBookmarkedCoursesForMyFomfQueryVariables
    >(Operations.GetBookmarkedCoursesForMyFOMF, options);
}
export function useGetBookmarkedCoursesForMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBookmarkedCoursesForMyFomfQuery,
              GetBookmarkedCoursesForMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBookmarkedCoursesForMyFomfQuery,
        GetBookmarkedCoursesForMyFomfQueryVariables
    >(Operations.GetBookmarkedCoursesForMyFOMF, options);
}
export type GetBookmarkedCoursesForMyFomfQueryHookResult = ReturnType<
    typeof useGetBookmarkedCoursesForMyFomfQuery
>;
export type GetBookmarkedCoursesForMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetBookmarkedCoursesForMyFomfLazyQuery
>;
export type GetBookmarkedCoursesForMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetBookmarkedCoursesForMyFomfSuspenseQuery
>;
export type GetBookmarkedCoursesForMyFomfQueryResult = Apollo.QueryResult<
    GetBookmarkedCoursesForMyFomfQuery,
    GetBookmarkedCoursesForMyFomfQueryVariables
>;

/**
 * __useGetBookmarkedDocumentsForMyFomfQuery__
 *
 * To run a query within a React component, call `useGetBookmarkedDocumentsForMyFomfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkedDocumentsForMyFomfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkedDocumentsForMyFomfQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetBookmarkedDocumentsForMyFomfQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetBookmarkedDocumentsForMyFomfQuery,
        GetBookmarkedDocumentsForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetBookmarkedDocumentsForMyFomfQuery,
        GetBookmarkedDocumentsForMyFomfQueryVariables
    >(Operations.GetBookmarkedDocumentsForMyFOMF, options);
}
export function useGetBookmarkedDocumentsForMyFomfLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetBookmarkedDocumentsForMyFomfQuery,
        GetBookmarkedDocumentsForMyFomfQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetBookmarkedDocumentsForMyFomfQuery,
        GetBookmarkedDocumentsForMyFomfQueryVariables
    >(Operations.GetBookmarkedDocumentsForMyFOMF, options);
}
export function useGetBookmarkedDocumentsForMyFomfSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetBookmarkedDocumentsForMyFomfQuery,
              GetBookmarkedDocumentsForMyFomfQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetBookmarkedDocumentsForMyFomfQuery,
        GetBookmarkedDocumentsForMyFomfQueryVariables
    >(Operations.GetBookmarkedDocumentsForMyFOMF, options);
}
export type GetBookmarkedDocumentsForMyFomfQueryHookResult = ReturnType<
    typeof useGetBookmarkedDocumentsForMyFomfQuery
>;
export type GetBookmarkedDocumentsForMyFomfLazyQueryHookResult = ReturnType<
    typeof useGetBookmarkedDocumentsForMyFomfLazyQuery
>;
export type GetBookmarkedDocumentsForMyFomfSuspenseQueryHookResult = ReturnType<
    typeof useGetBookmarkedDocumentsForMyFomfSuspenseQuery
>;
export type GetBookmarkedDocumentsForMyFomfQueryResult = Apollo.QueryResult<
    GetBookmarkedDocumentsForMyFomfQuery,
    GetBookmarkedDocumentsForMyFomfQueryVariables
>;

/**
 * __useGetUserSpecialitiesQuery__
 *
 * To run a query within a React component, call `useGetUserSpecialitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSpecialitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSpecialitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetUserSpecialitiesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserSpecialitiesQuery,
        GetUserSpecialitiesQueryVariables
    > &
        ({ variables: GetUserSpecialitiesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserSpecialitiesQuery, GetUserSpecialitiesQueryVariables>(
        Operations.GetUserSpecialities,
        options
    );
}
export function useGetUserSpecialitiesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserSpecialitiesQuery,
        GetUserSpecialitiesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUserSpecialitiesQuery, GetUserSpecialitiesQueryVariables>(
        Operations.GetUserSpecialities,
        options
    );
}
export function useGetUserSpecialitiesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserSpecialitiesQuery,
              GetUserSpecialitiesQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetUserSpecialitiesQuery, GetUserSpecialitiesQueryVariables>(
        Operations.GetUserSpecialities,
        options
    );
}
export type GetUserSpecialitiesQueryHookResult = ReturnType<typeof useGetUserSpecialitiesQuery>;
export type GetUserSpecialitiesLazyQueryHookResult = ReturnType<
    typeof useGetUserSpecialitiesLazyQuery
>;
export type GetUserSpecialitiesSuspenseQueryHookResult = ReturnType<
    typeof useGetUserSpecialitiesSuspenseQuery
>;
export type GetUserSpecialitiesQueryResult = Apollo.QueryResult<
    GetUserSpecialitiesQuery,
    GetUserSpecialitiesQueryVariables
>;

/**
 * __useGetRecommendedContentsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedContentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetRecommendedContentsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetRecommendedContentsQuery,
        GetRecommendedContentsQueryVariables
    > &
        ({ variables: GetRecommendedContentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetRecommendedContentsQuery, GetRecommendedContentsQueryVariables>(
        Operations.GetRecommendedContents,
        options
    );
}
export function useGetRecommendedContentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetRecommendedContentsQuery,
        GetRecommendedContentsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetRecommendedContentsQuery, GetRecommendedContentsQueryVariables>(
        Operations.GetRecommendedContents,
        options
    );
}
export function useGetRecommendedContentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetRecommendedContentsQuery,
              GetRecommendedContentsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetRecommendedContentsQuery,
        GetRecommendedContentsQueryVariables
    >(Operations.GetRecommendedContents, options);
}
export type GetRecommendedContentsQueryHookResult = ReturnType<
    typeof useGetRecommendedContentsQuery
>;
export type GetRecommendedContentsLazyQueryHookResult = ReturnType<
    typeof useGetRecommendedContentsLazyQuery
>;
export type GetRecommendedContentsSuspenseQueryHookResult = ReturnType<
    typeof useGetRecommendedContentsSuspenseQuery
>;
export type GetRecommendedContentsQueryResult = Apollo.QueryResult<
    GetRecommendedContentsQuery,
    GetRecommendedContentsQueryVariables
>;

/**
 * __useGetOnDemandContentQuestionsByIdQuery__
 *
 * To run a query within a React component, call `useGetOnDemandContentQuestionsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnDemandContentQuestionsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnDemandContentQuestionsByIdQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetOnDemandContentQuestionsByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetOnDemandContentQuestionsByIdQuery,
        GetOnDemandContentQuestionsByIdQueryVariables
    > &
        (
            | { variables: GetOnDemandContentQuestionsByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetOnDemandContentQuestionsByIdQuery,
        GetOnDemandContentQuestionsByIdQueryVariables
    >(Operations.GetOnDemandContentQuestionsById, options);
}
export function useGetOnDemandContentQuestionsByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetOnDemandContentQuestionsByIdQuery,
        GetOnDemandContentQuestionsByIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetOnDemandContentQuestionsByIdQuery,
        GetOnDemandContentQuestionsByIdQueryVariables
    >(Operations.GetOnDemandContentQuestionsById, options);
}
export function useGetOnDemandContentQuestionsByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetOnDemandContentQuestionsByIdQuery,
              GetOnDemandContentQuestionsByIdQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetOnDemandContentQuestionsByIdQuery,
        GetOnDemandContentQuestionsByIdQueryVariables
    >(Operations.GetOnDemandContentQuestionsById, options);
}
export type GetOnDemandContentQuestionsByIdQueryHookResult = ReturnType<
    typeof useGetOnDemandContentQuestionsByIdQuery
>;
export type GetOnDemandContentQuestionsByIdLazyQueryHookResult = ReturnType<
    typeof useGetOnDemandContentQuestionsByIdLazyQuery
>;
export type GetOnDemandContentQuestionsByIdSuspenseQueryHookResult = ReturnType<
    typeof useGetOnDemandContentQuestionsByIdSuspenseQuery
>;
export type GetOnDemandContentQuestionsByIdQueryResult = Apollo.QueryResult<
    GetOnDemandContentQuestionsByIdQuery,
    GetOnDemandContentQuestionsByIdQueryVariables
>;

/**
 * __useOnDemandCoursesQuery__
 *
 * To run a query within a React component, call `useOnDemandCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnDemandCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDemandCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useOnDemandCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<OnDemandCoursesQuery, OnDemandCoursesQueryVariables> &
        ({ variables: OnDemandCoursesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<OnDemandCoursesQuery, OnDemandCoursesQueryVariables>(
        Operations.OnDemandCourses,
        options
    );
}
export function useOnDemandCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<OnDemandCoursesQuery, OnDemandCoursesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<OnDemandCoursesQuery, OnDemandCoursesQueryVariables>(
        Operations.OnDemandCourses,
        options
    );
}
export function useOnDemandCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<OnDemandCoursesQuery, OnDemandCoursesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<OnDemandCoursesQuery, OnDemandCoursesQueryVariables>(
        Operations.OnDemandCourses,
        options
    );
}
export type OnDemandCoursesQueryHookResult = ReturnType<typeof useOnDemandCoursesQuery>;
export type OnDemandCoursesLazyQueryHookResult = ReturnType<typeof useOnDemandCoursesLazyQuery>;
export type OnDemandCoursesSuspenseQueryHookResult = ReturnType<
    typeof useOnDemandCoursesSuspenseQuery
>;
export type OnDemandCoursesQueryResult = Apollo.QueryResult<
    OnDemandCoursesQuery,
    OnDemandCoursesQueryVariables
>;

/**
 * __useOnDemandCourseForPlayerByIdQuery__
 *
 * To run a query within a React component, call `useOnDemandCourseForPlayerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnDemandCourseForPlayerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDemandCourseForPlayerByIdQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useOnDemandCourseForPlayerByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        OnDemandCourseForPlayerByIdQuery,
        OnDemandCourseForPlayerByIdQueryVariables
    > &
        (
            | { variables: OnDemandCourseForPlayerByIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        OnDemandCourseForPlayerByIdQuery,
        OnDemandCourseForPlayerByIdQueryVariables
    >(Operations.OnDemandCourseForPlayerById, options);
}
export function useOnDemandCourseForPlayerByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        OnDemandCourseForPlayerByIdQuery,
        OnDemandCourseForPlayerByIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        OnDemandCourseForPlayerByIdQuery,
        OnDemandCourseForPlayerByIdQueryVariables
    >(Operations.OnDemandCourseForPlayerById, options);
}
export function useOnDemandCourseForPlayerByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              OnDemandCourseForPlayerByIdQuery,
              OnDemandCourseForPlayerByIdQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        OnDemandCourseForPlayerByIdQuery,
        OnDemandCourseForPlayerByIdQueryVariables
    >(Operations.OnDemandCourseForPlayerById, options);
}
export type OnDemandCourseForPlayerByIdQueryHookResult = ReturnType<
    typeof useOnDemandCourseForPlayerByIdQuery
>;
export type OnDemandCourseForPlayerByIdLazyQueryHookResult = ReturnType<
    typeof useOnDemandCourseForPlayerByIdLazyQuery
>;
export type OnDemandCourseForPlayerByIdSuspenseQueryHookResult = ReturnType<
    typeof useOnDemandCourseForPlayerByIdSuspenseQuery
>;
export type OnDemandCourseForPlayerByIdQueryResult = Apollo.QueryResult<
    OnDemandCourseForPlayerByIdQuery,
    OnDemandCourseForPlayerByIdQueryVariables
>;

/**
 * __useOnDemandCourseCertificateByCourseIdQuery__
 *
 * To run a query within a React component, call `useOnDemandCourseCertificateByCourseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnDemandCourseCertificateByCourseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDemandCourseCertificateByCourseIdQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useOnDemandCourseCertificateByCourseIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        OnDemandCourseCertificateByCourseIdQuery,
        OnDemandCourseCertificateByCourseIdQueryVariables
    > &
        (
            | { variables: OnDemandCourseCertificateByCourseIdQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        OnDemandCourseCertificateByCourseIdQuery,
        OnDemandCourseCertificateByCourseIdQueryVariables
    >(Operations.OnDemandCourseCertificateByCourseId, options);
}
export function useOnDemandCourseCertificateByCourseIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        OnDemandCourseCertificateByCourseIdQuery,
        OnDemandCourseCertificateByCourseIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        OnDemandCourseCertificateByCourseIdQuery,
        OnDemandCourseCertificateByCourseIdQueryVariables
    >(Operations.OnDemandCourseCertificateByCourseId, options);
}
export function useOnDemandCourseCertificateByCourseIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              OnDemandCourseCertificateByCourseIdQuery,
              OnDemandCourseCertificateByCourseIdQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        OnDemandCourseCertificateByCourseIdQuery,
        OnDemandCourseCertificateByCourseIdQueryVariables
    >(Operations.OnDemandCourseCertificateByCourseId, options);
}
export type OnDemandCourseCertificateByCourseIdQueryHookResult = ReturnType<
    typeof useOnDemandCourseCertificateByCourseIdQuery
>;
export type OnDemandCourseCertificateByCourseIdLazyQueryHookResult = ReturnType<
    typeof useOnDemandCourseCertificateByCourseIdLazyQuery
>;
export type OnDemandCourseCertificateByCourseIdSuspenseQueryHookResult = ReturnType<
    typeof useOnDemandCourseCertificateByCourseIdSuspenseQuery
>;
export type OnDemandCourseCertificateByCourseIdQueryResult = Apollo.QueryResult<
    OnDemandCourseCertificateByCourseIdQuery,
    OnDemandCourseCertificateByCourseIdQueryVariables
>;

/**
 * __useOnDemandCourseByIdQuery__
 *
 * To run a query within a React component, call `useOnDemandCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnDemandCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDemandCourseByIdQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useOnDemandCourseByIdQuery(
    baseOptions: Apollo.QueryHookOptions<
        OnDemandCourseByIdQuery,
        OnDemandCourseByIdQueryVariables
    > &
        ({ variables: OnDemandCourseByIdQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<OnDemandCourseByIdQuery, OnDemandCourseByIdQueryVariables>(
        Operations.OnDemandCourseById,
        options
    );
}
export function useOnDemandCourseByIdLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        OnDemandCourseByIdQuery,
        OnDemandCourseByIdQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<OnDemandCourseByIdQuery, OnDemandCourseByIdQueryVariables>(
        Operations.OnDemandCourseById,
        options
    );
}
export function useOnDemandCourseByIdSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<OnDemandCourseByIdQuery, OnDemandCourseByIdQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<OnDemandCourseByIdQuery, OnDemandCourseByIdQueryVariables>(
        Operations.OnDemandCourseById,
        options
    );
}
export type OnDemandCourseByIdQueryHookResult = ReturnType<typeof useOnDemandCourseByIdQuery>;
export type OnDemandCourseByIdLazyQueryHookResult = ReturnType<
    typeof useOnDemandCourseByIdLazyQuery
>;
export type OnDemandCourseByIdSuspenseQueryHookResult = ReturnType<
    typeof useOnDemandCourseByIdSuspenseQuery
>;
export type OnDemandCourseByIdQueryResult = Apollo.QueryResult<
    OnDemandCourseByIdQuery,
    OnDemandCourseByIdQueryVariables
>;

/**
 * __useEventPriceListQuery__
 *
 * To run a query within a React component, call `useEventPriceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPriceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPriceListQuery({
 *   variables: {
 *      ubEventId: // value for 'ubEventId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useEventPriceListQuery(
    baseOptions: Apollo.QueryHookOptions<EventPriceListQuery, EventPriceListQueryVariables> &
        ({ variables: EventPriceListQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<EventPriceListQuery, EventPriceListQueryVariables>(
        Operations.EventPriceList,
        options
    );
}
export function useEventPriceListLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<EventPriceListQuery, EventPriceListQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<EventPriceListQuery, EventPriceListQueryVariables>(
        Operations.EventPriceList,
        options
    );
}
export function useEventPriceListSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<EventPriceListQuery, EventPriceListQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<EventPriceListQuery, EventPriceListQueryVariables>(
        Operations.EventPriceList,
        options
    );
}
export type EventPriceListQueryHookResult = ReturnType<typeof useEventPriceListQuery>;
export type EventPriceListLazyQueryHookResult = ReturnType<typeof useEventPriceListLazyQuery>;
export type EventPriceListSuspenseQueryHookResult = ReturnType<
    typeof useEventPriceListSuspenseQuery
>;
export type EventPriceListQueryResult = Apollo.QueryResult<
    EventPriceListQuery,
    EventPriceListQueryVariables
>;

/**
 * __useContentDocumentsExtendedQuery__
 *
 * To run a query within a React component, call `useContentDocumentsExtendedQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDocumentsExtendedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDocumentsExtendedQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useContentDocumentsExtendedQuery(
    baseOptions: Apollo.QueryHookOptions<
        ContentDocumentsExtendedQuery,
        ContentDocumentsExtendedQueryVariables
    > &
        ({ variables: ContentDocumentsExtendedQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<ContentDocumentsExtendedQuery, ContentDocumentsExtendedQueryVariables>(
        Operations.ContentDocumentsExtended,
        options
    );
}
export function useContentDocumentsExtendedLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ContentDocumentsExtendedQuery,
        ContentDocumentsExtendedQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        ContentDocumentsExtendedQuery,
        ContentDocumentsExtendedQueryVariables
    >(Operations.ContentDocumentsExtended, options);
}
export function useContentDocumentsExtendedSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              ContentDocumentsExtendedQuery,
              ContentDocumentsExtendedQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        ContentDocumentsExtendedQuery,
        ContentDocumentsExtendedQueryVariables
    >(Operations.ContentDocumentsExtended, options);
}
export type ContentDocumentsExtendedQueryHookResult = ReturnType<
    typeof useContentDocumentsExtendedQuery
>;
export type ContentDocumentsExtendedLazyQueryHookResult = ReturnType<
    typeof useContentDocumentsExtendedLazyQuery
>;
export type ContentDocumentsExtendedSuspenseQueryHookResult = ReturnType<
    typeof useContentDocumentsExtendedSuspenseQuery
>;
export type ContentDocumentsExtendedQueryResult = Apollo.QueryResult<
    ContentDocumentsExtendedQuery,
    ContentDocumentsExtendedQueryVariables
>;

/**
 * __useContentsWithProgramSchedulesQuery__
 *
 * To run a query within a React component, call `useContentsWithProgramSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentsWithProgramSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentsWithProgramSchedulesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useContentsWithProgramSchedulesQuery(
    baseOptions: Apollo.QueryHookOptions<
        ContentsWithProgramSchedulesQuery,
        ContentsWithProgramSchedulesQueryVariables
    > &
        (
            | { variables: ContentsWithProgramSchedulesQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        ContentsWithProgramSchedulesQuery,
        ContentsWithProgramSchedulesQueryVariables
    >(Operations.ContentsWithProgramSchedules, options);
}
export function useContentsWithProgramSchedulesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ContentsWithProgramSchedulesQuery,
        ContentsWithProgramSchedulesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        ContentsWithProgramSchedulesQuery,
        ContentsWithProgramSchedulesQueryVariables
    >(Operations.ContentsWithProgramSchedules, options);
}
export function useContentsWithProgramSchedulesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              ContentsWithProgramSchedulesQuery,
              ContentsWithProgramSchedulesQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        ContentsWithProgramSchedulesQuery,
        ContentsWithProgramSchedulesQueryVariables
    >(Operations.ContentsWithProgramSchedules, options);
}
export type ContentsWithProgramSchedulesQueryHookResult = ReturnType<
    typeof useContentsWithProgramSchedulesQuery
>;
export type ContentsWithProgramSchedulesLazyQueryHookResult = ReturnType<
    typeof useContentsWithProgramSchedulesLazyQuery
>;
export type ContentsWithProgramSchedulesSuspenseQueryHookResult = ReturnType<
    typeof useContentsWithProgramSchedulesSuspenseQuery
>;
export type ContentsWithProgramSchedulesQueryResult = Apollo.QueryResult<
    ContentsWithProgramSchedulesQuery,
    ContentsWithProgramSchedulesQueryVariables
>;

/**
 * __usePartnerForumAllCompanyVideosQuery__
 *
 * To run a query within a React component, call `usePartnerForumAllCompanyVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerForumAllCompanyVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerForumAllCompanyVideosQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePartnerForumAllCompanyVideosQuery(
    baseOptions: Apollo.QueryHookOptions<
        PartnerForumAllCompanyVideosQuery,
        PartnerForumAllCompanyVideosQueryVariables
    > &
        (
            | { variables: PartnerForumAllCompanyVideosQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        PartnerForumAllCompanyVideosQuery,
        PartnerForumAllCompanyVideosQueryVariables
    >(Operations.PartnerForumAllCompanyVideos, options);
}
export function usePartnerForumAllCompanyVideosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PartnerForumAllCompanyVideosQuery,
        PartnerForumAllCompanyVideosQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        PartnerForumAllCompanyVideosQuery,
        PartnerForumAllCompanyVideosQueryVariables
    >(Operations.PartnerForumAllCompanyVideos, options);
}
export function usePartnerForumAllCompanyVideosSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              PartnerForumAllCompanyVideosQuery,
              PartnerForumAllCompanyVideosQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        PartnerForumAllCompanyVideosQuery,
        PartnerForumAllCompanyVideosQueryVariables
    >(Operations.PartnerForumAllCompanyVideos, options);
}
export type PartnerForumAllCompanyVideosQueryHookResult = ReturnType<
    typeof usePartnerForumAllCompanyVideosQuery
>;
export type PartnerForumAllCompanyVideosLazyQueryHookResult = ReturnType<
    typeof usePartnerForumAllCompanyVideosLazyQuery
>;
export type PartnerForumAllCompanyVideosSuspenseQueryHookResult = ReturnType<
    typeof usePartnerForumAllCompanyVideosSuspenseQuery
>;
export type PartnerForumAllCompanyVideosQueryResult = Apollo.QueryResult<
    PartnerForumAllCompanyVideosQuery,
    PartnerForumAllCompanyVideosQueryVariables
>;

/**
 * __usePartnerForumOverviewVideosQuery__
 *
 * To run a query within a React component, call `usePartnerForumOverviewVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerForumOverviewVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerForumOverviewVideosQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePartnerForumOverviewVideosQuery(
    baseOptions: Apollo.QueryHookOptions<
        PartnerForumOverviewVideosQuery,
        PartnerForumOverviewVideosQueryVariables
    > &
        (
            | { variables: PartnerForumOverviewVideosQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        PartnerForumOverviewVideosQuery,
        PartnerForumOverviewVideosQueryVariables
    >(Operations.PartnerForumOverviewVideos, options);
}
export function usePartnerForumOverviewVideosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PartnerForumOverviewVideosQuery,
        PartnerForumOverviewVideosQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        PartnerForumOverviewVideosQuery,
        PartnerForumOverviewVideosQueryVariables
    >(Operations.PartnerForumOverviewVideos, options);
}
export function usePartnerForumOverviewVideosSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              PartnerForumOverviewVideosQuery,
              PartnerForumOverviewVideosQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        PartnerForumOverviewVideosQuery,
        PartnerForumOverviewVideosQueryVariables
    >(Operations.PartnerForumOverviewVideos, options);
}
export type PartnerForumOverviewVideosQueryHookResult = ReturnType<
    typeof usePartnerForumOverviewVideosQuery
>;
export type PartnerForumOverviewVideosLazyQueryHookResult = ReturnType<
    typeof usePartnerForumOverviewVideosLazyQuery
>;
export type PartnerForumOverviewVideosSuspenseQueryHookResult = ReturnType<
    typeof usePartnerForumOverviewVideosSuspenseQuery
>;
export type PartnerForumOverviewVideosQueryResult = Apollo.QueryResult<
    PartnerForumOverviewVideosQuery,
    PartnerForumOverviewVideosQueryVariables
>;

/**
 * __useSimpleContentsQuery__
 *
 * To run a query within a React component, call `useSimpleContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleContentsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useSimpleContentsQuery(
    baseOptions: Apollo.QueryHookOptions<SimpleContentsQuery, SimpleContentsQueryVariables> &
        ({ variables: SimpleContentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<SimpleContentsQuery, SimpleContentsQueryVariables>(
        Operations.SimpleContents,
        options
    );
}
export function useSimpleContentsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<SimpleContentsQuery, SimpleContentsQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<SimpleContentsQuery, SimpleContentsQueryVariables>(
        Operations.SimpleContents,
        options
    );
}
export function useSimpleContentsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<SimpleContentsQuery, SimpleContentsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<SimpleContentsQuery, SimpleContentsQueryVariables>(
        Operations.SimpleContents,
        options
    );
}
export type SimpleContentsQueryHookResult = ReturnType<typeof useSimpleContentsQuery>;
export type SimpleContentsLazyQueryHookResult = ReturnType<typeof useSimpleContentsLazyQuery>;
export type SimpleContentsSuspenseQueryHookResult = ReturnType<
    typeof useSimpleContentsSuspenseQuery
>;
export type SimpleContentsQueryResult = Apollo.QueryResult<
    SimpleContentsQuery,
    SimpleContentsQueryVariables
>;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetCompanyQuery(
    baseOptions?: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(
        Operations.GetCompany,
        options
    );
}
export function useGetCompanyLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(
        Operations.GetCompany,
        options
    );
}
export function useGetCompanySuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(
        Operations.GetCompany,
        options
    );
}
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;

/**
 * __useGetCompanyBasicDataQuery__
 *
 * To run a query within a React component, call `useGetCompanyBasicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBasicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBasicDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useGetCompanyBasicDataQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetCompanyBasicDataQuery,
        GetCompanyBasicDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetCompanyBasicDataQuery, GetCompanyBasicDataQueryVariables>(
        Operations.GetCompanyBasicData,
        options
    );
}
export function useGetCompanyBasicDataLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCompanyBasicDataQuery,
        GetCompanyBasicDataQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetCompanyBasicDataQuery, GetCompanyBasicDataQueryVariables>(
        Operations.GetCompanyBasicData,
        options
    );
}
export function useGetCompanyBasicDataSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetCompanyBasicDataQuery,
              GetCompanyBasicDataQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetCompanyBasicDataQuery, GetCompanyBasicDataQueryVariables>(
        Operations.GetCompanyBasicData,
        options
    );
}
export type GetCompanyBasicDataQueryHookResult = ReturnType<typeof useGetCompanyBasicDataQuery>;
export type GetCompanyBasicDataLazyQueryHookResult = ReturnType<
    typeof useGetCompanyBasicDataLazyQuery
>;
export type GetCompanyBasicDataSuspenseQueryHookResult = ReturnType<
    typeof useGetCompanyBasicDataSuspenseQuery
>;
export type GetCompanyBasicDataQueryResult = Apollo.QueryResult<
    GetCompanyBasicDataQuery,
    GetCompanyBasicDataQueryVariables
>;

/**
 * __useMediathekCoursesQuery__
 *
 * To run a query within a React component, call `useMediathekCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediathekCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediathekCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useMediathekCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<MediathekCoursesQuery, MediathekCoursesQueryVariables> &
        ({ variables: MediathekCoursesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<MediathekCoursesQuery, MediathekCoursesQueryVariables>(
        Operations.MediathekCourses,
        options
    );
}
export function useMediathekCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<MediathekCoursesQuery, MediathekCoursesQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<MediathekCoursesQuery, MediathekCoursesQueryVariables>(
        Operations.MediathekCourses,
        options
    );
}
export function useMediathekCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<MediathekCoursesQuery, MediathekCoursesQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<MediathekCoursesQuery, MediathekCoursesQueryVariables>(
        Operations.MediathekCourses,
        options
    );
}
export type MediathekCoursesQueryHookResult = ReturnType<typeof useMediathekCoursesQuery>;
export type MediathekCoursesLazyQueryHookResult = ReturnType<typeof useMediathekCoursesLazyQuery>;
export type MediathekCoursesSuspenseQueryHookResult = ReturnType<
    typeof useMediathekCoursesSuspenseQuery
>;
export type MediathekCoursesQueryResult = Apollo.QueryResult<
    MediathekCoursesQuery,
    MediathekCoursesQueryVariables
>;

/**
 * __useGetUserPaymentStatusQuery__
 *
 * To run a query within a React component, call `useGetUserPaymentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPaymentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPaymentStatusQuery({
 *   variables: {
 *      paymentReference: // value for 'paymentReference'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useGetUserPaymentStatusQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserPaymentStatusQuery,
        GetUserPaymentStatusQueryVariables
    > &
        ({ variables: GetUserPaymentStatusQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserPaymentStatusQuery, GetUserPaymentStatusQueryVariables>(
        Operations.GetUserPaymentStatus,
        options
    );
}
export function useGetUserPaymentStatusLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserPaymentStatusQuery,
        GetUserPaymentStatusQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUserPaymentStatusQuery, GetUserPaymentStatusQueryVariables>(
        Operations.GetUserPaymentStatus,
        options
    );
}
export function useGetUserPaymentStatusSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserPaymentStatusQuery,
              GetUserPaymentStatusQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetUserPaymentStatusQuery, GetUserPaymentStatusQueryVariables>(
        Operations.GetUserPaymentStatus,
        options
    );
}
export type GetUserPaymentStatusQueryHookResult = ReturnType<typeof useGetUserPaymentStatusQuery>;
export type GetUserPaymentStatusLazyQueryHookResult = ReturnType<
    typeof useGetUserPaymentStatusLazyQuery
>;
export type GetUserPaymentStatusSuspenseQueryHookResult = ReturnType<
    typeof useGetUserPaymentStatusSuspenseQuery
>;
export type GetUserPaymentStatusQueryResult = Apollo.QueryResult<
    GetUserPaymentStatusQuery,
    GetUserPaymentStatusQueryVariables
>;

/**
 * __useGetTenantPartnerCoursesQuery__
 *
 * To run a query within a React component, call `useGetTenantPartnerCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantPartnerCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantPartnerCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetTenantPartnerCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetTenantPartnerCoursesQuery,
        GetTenantPartnerCoursesQueryVariables
    > &
        ({ variables: GetTenantPartnerCoursesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetTenantPartnerCoursesQuery, GetTenantPartnerCoursesQueryVariables>(
        Operations.GetTenantPartnerCourses,
        options
    );
}
export function useGetTenantPartnerCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTenantPartnerCoursesQuery,
        GetTenantPartnerCoursesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetTenantPartnerCoursesQuery, GetTenantPartnerCoursesQueryVariables>(
        Operations.GetTenantPartnerCourses,
        options
    );
}
export function useGetTenantPartnerCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTenantPartnerCoursesQuery,
              GetTenantPartnerCoursesQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTenantPartnerCoursesQuery,
        GetTenantPartnerCoursesQueryVariables
    >(Operations.GetTenantPartnerCourses, options);
}
export type GetTenantPartnerCoursesQueryHookResult = ReturnType<
    typeof useGetTenantPartnerCoursesQuery
>;
export type GetTenantPartnerCoursesLazyQueryHookResult = ReturnType<
    typeof useGetTenantPartnerCoursesLazyQuery
>;
export type GetTenantPartnerCoursesSuspenseQueryHookResult = ReturnType<
    typeof useGetTenantPartnerCoursesSuspenseQuery
>;
export type GetTenantPartnerCoursesQueryResult = Apollo.QueryResult<
    GetTenantPartnerCoursesQuery,
    GetTenantPartnerCoursesQueryVariables
>;

/**
 * __useGetUserRemindersForEventQuery__
 *
 * To run a query within a React component, call `useGetUserRemindersForEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRemindersForEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRemindersForEventQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      eventUbId: // value for 'eventUbId'
 *   },
 * });
 */
export function useGetUserRemindersForEventQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetUserRemindersForEventQuery,
        GetUserRemindersForEventQueryVariables
    > &
        ({ variables: GetUserRemindersForEventQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUserRemindersForEventQuery, GetUserRemindersForEventQueryVariables>(
        Operations.GetUserRemindersForEvent,
        options
    );
}
export function useGetUserRemindersForEventLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetUserRemindersForEventQuery,
        GetUserRemindersForEventQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetUserRemindersForEventQuery,
        GetUserRemindersForEventQueryVariables
    >(Operations.GetUserRemindersForEvent, options);
}
export function useGetUserRemindersForEventSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetUserRemindersForEventQuery,
              GetUserRemindersForEventQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetUserRemindersForEventQuery,
        GetUserRemindersForEventQueryVariables
    >(Operations.GetUserRemindersForEvent, options);
}
export type GetUserRemindersForEventQueryHookResult = ReturnType<
    typeof useGetUserRemindersForEventQuery
>;
export type GetUserRemindersForEventLazyQueryHookResult = ReturnType<
    typeof useGetUserRemindersForEventLazyQuery
>;
export type GetUserRemindersForEventSuspenseQueryHookResult = ReturnType<
    typeof useGetUserRemindersForEventSuspenseQuery
>;
export type GetUserRemindersForEventQueryResult = Apollo.QueryResult<
    GetUserRemindersForEventQuery,
    GetUserRemindersForEventQueryVariables
>;

/**
 * __useGetHandoutsLandingCoursesQuery__
 *
 * To run a query within a React component, call `useGetHandoutsLandingCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoutsLandingCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoutsLandingCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetHandoutsLandingCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHandoutsLandingCoursesQuery,
        GetHandoutsLandingCoursesQueryVariables
    > &
        ({ variables: GetHandoutsLandingCoursesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHandoutsLandingCoursesQuery, GetHandoutsLandingCoursesQueryVariables>(
        Operations.GetHandoutsLandingCourses,
        options
    );
}
export function useGetHandoutsLandingCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHandoutsLandingCoursesQuery,
        GetHandoutsLandingCoursesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetHandoutsLandingCoursesQuery,
        GetHandoutsLandingCoursesQueryVariables
    >(Operations.GetHandoutsLandingCourses, options);
}
export function useGetHandoutsLandingCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHandoutsLandingCoursesQuery,
              GetHandoutsLandingCoursesQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetHandoutsLandingCoursesQuery,
        GetHandoutsLandingCoursesQueryVariables
    >(Operations.GetHandoutsLandingCourses, options);
}
export type GetHandoutsLandingCoursesQueryHookResult = ReturnType<
    typeof useGetHandoutsLandingCoursesQuery
>;
export type GetHandoutsLandingCoursesLazyQueryHookResult = ReturnType<
    typeof useGetHandoutsLandingCoursesLazyQuery
>;
export type GetHandoutsLandingCoursesSuspenseQueryHookResult = ReturnType<
    typeof useGetHandoutsLandingCoursesSuspenseQuery
>;
export type GetHandoutsLandingCoursesQueryResult = Apollo.QueryResult<
    GetHandoutsLandingCoursesQuery,
    GetHandoutsLandingCoursesQueryVariables
>;

/**
 * __useGetTopicsForQueryFilterQuery__
 *
 * To run a query within a React component, call `useGetTopicsForQueryFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicsForQueryFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicsForQueryFilterQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetTopicsForQueryFilterQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetTopicsForQueryFilterQuery,
        GetTopicsForQueryFilterQueryVariables
    > &
        ({ variables: GetTopicsForQueryFilterQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetTopicsForQueryFilterQuery, GetTopicsForQueryFilterQueryVariables>(
        Operations.GetTopicsForQueryFilter,
        options
    );
}
export function useGetTopicsForQueryFilterLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetTopicsForQueryFilterQuery,
        GetTopicsForQueryFilterQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetTopicsForQueryFilterQuery, GetTopicsForQueryFilterQueryVariables>(
        Operations.GetTopicsForQueryFilter,
        options
    );
}
export function useGetTopicsForQueryFilterSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetTopicsForQueryFilterQuery,
              GetTopicsForQueryFilterQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetTopicsForQueryFilterQuery,
        GetTopicsForQueryFilterQueryVariables
    >(Operations.GetTopicsForQueryFilter, options);
}
export type GetTopicsForQueryFilterQueryHookResult = ReturnType<
    typeof useGetTopicsForQueryFilterQuery
>;
export type GetTopicsForQueryFilterLazyQueryHookResult = ReturnType<
    typeof useGetTopicsForQueryFilterLazyQuery
>;
export type GetTopicsForQueryFilterSuspenseQueryHookResult = ReturnType<
    typeof useGetTopicsForQueryFilterSuspenseQuery
>;
export type GetTopicsForQueryFilterQueryResult = Apollo.QueryResult<
    GetTopicsForQueryFilterQuery,
    GetTopicsForQueryFilterQueryVariables
>;

/**
 * __useGetHandoutsDetailsQuery__
 *
 * To run a query within a React component, call `useGetHandoutsDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoutsDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoutsDetailsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetHandoutsDetailsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHandoutsDetailsQuery,
        GetHandoutsDetailsQueryVariables
    > &
        ({ variables: GetHandoutsDetailsQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHandoutsDetailsQuery, GetHandoutsDetailsQueryVariables>(
        Operations.GetHandoutsDetails,
        options
    );
}
export function useGetHandoutsDetailsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHandoutsDetailsQuery,
        GetHandoutsDetailsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHandoutsDetailsQuery, GetHandoutsDetailsQueryVariables>(
        Operations.GetHandoutsDetails,
        options
    );
}
export function useGetHandoutsDetailsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetHandoutsDetailsQuery, GetHandoutsDetailsQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetHandoutsDetailsQuery, GetHandoutsDetailsQueryVariables>(
        Operations.GetHandoutsDetails,
        options
    );
}
export type GetHandoutsDetailsQueryHookResult = ReturnType<typeof useGetHandoutsDetailsQuery>;
export type GetHandoutsDetailsLazyQueryHookResult = ReturnType<
    typeof useGetHandoutsDetailsLazyQuery
>;
export type GetHandoutsDetailsSuspenseQueryHookResult = ReturnType<
    typeof useGetHandoutsDetailsSuspenseQuery
>;
export type GetHandoutsDetailsQueryResult = Apollo.QueryResult<
    GetHandoutsDetailsQuery,
    GetHandoutsDetailsQueryVariables
>;

/**
 * __useGetDetailsPageHandoutsCoursesQuery__
 *
 * To run a query within a React component, call `useGetDetailsPageHandoutsCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDetailsPageHandoutsCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetailsPageHandoutsCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetDetailsPageHandoutsCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetDetailsPageHandoutsCoursesQuery,
        GetDetailsPageHandoutsCoursesQueryVariables
    > &
        (
            | { variables: GetDetailsPageHandoutsCoursesQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetDetailsPageHandoutsCoursesQuery,
        GetDetailsPageHandoutsCoursesQueryVariables
    >(Operations.GetDetailsPageHandoutsCourses, options);
}
export function useGetDetailsPageHandoutsCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetDetailsPageHandoutsCoursesQuery,
        GetDetailsPageHandoutsCoursesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetDetailsPageHandoutsCoursesQuery,
        GetDetailsPageHandoutsCoursesQueryVariables
    >(Operations.GetDetailsPageHandoutsCourses, options);
}
export function useGetDetailsPageHandoutsCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetDetailsPageHandoutsCoursesQuery,
              GetDetailsPageHandoutsCoursesQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetDetailsPageHandoutsCoursesQuery,
        GetDetailsPageHandoutsCoursesQueryVariables
    >(Operations.GetDetailsPageHandoutsCourses, options);
}
export type GetDetailsPageHandoutsCoursesQueryHookResult = ReturnType<
    typeof useGetDetailsPageHandoutsCoursesQuery
>;
export type GetDetailsPageHandoutsCoursesLazyQueryHookResult = ReturnType<
    typeof useGetDetailsPageHandoutsCoursesLazyQuery
>;
export type GetDetailsPageHandoutsCoursesSuspenseQueryHookResult = ReturnType<
    typeof useGetDetailsPageHandoutsCoursesSuspenseQuery
>;
export type GetDetailsPageHandoutsCoursesQueryResult = Apollo.QueryResult<
    GetDetailsPageHandoutsCoursesQuery,
    GetDetailsPageHandoutsCoursesQueryVariables
>;

/**
 * __useGetHandoutsCourseBookQueryQuery__
 *
 * To run a query within a React component, call `useGetHandoutsCourseBookQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoutsCourseBookQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoutsCourseBookQueryQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useGetHandoutsCourseBookQueryQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHandoutsCourseBookQueryQuery,
        GetHandoutsCourseBookQueryQueryVariables
    > &
        (
            | { variables: GetHandoutsCourseBookQueryQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetHandoutsCourseBookQueryQuery,
        GetHandoutsCourseBookQueryQueryVariables
    >(Operations.GetHandoutsCourseBookQuery, options);
}
export function useGetHandoutsCourseBookQueryLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHandoutsCourseBookQueryQuery,
        GetHandoutsCourseBookQueryQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetHandoutsCourseBookQueryQuery,
        GetHandoutsCourseBookQueryQueryVariables
    >(Operations.GetHandoutsCourseBookQuery, options);
}
export function useGetHandoutsCourseBookQuerySuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHandoutsCourseBookQueryQuery,
              GetHandoutsCourseBookQueryQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetHandoutsCourseBookQueryQuery,
        GetHandoutsCourseBookQueryQueryVariables
    >(Operations.GetHandoutsCourseBookQuery, options);
}
export type GetHandoutsCourseBookQueryQueryHookResult = ReturnType<
    typeof useGetHandoutsCourseBookQueryQuery
>;
export type GetHandoutsCourseBookQueryLazyQueryHookResult = ReturnType<
    typeof useGetHandoutsCourseBookQueryLazyQuery
>;
export type GetHandoutsCourseBookQuerySuspenseQueryHookResult = ReturnType<
    typeof useGetHandoutsCourseBookQuerySuspenseQuery
>;
export type GetHandoutsCourseBookQueryQueryResult = Apollo.QueryResult<
    GetHandoutsCourseBookQueryQuery,
    GetHandoutsCourseBookQueryQueryVariables
>;

/**
 * __useGetHandoutsCourseNotesQuery__
 *
 * To run a query within a React component, call `useGetHandoutsCourseNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoutsCourseNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoutsCourseNotesQuery({
 *   variables: {
 *      contentMediaId: // value for 'contentMediaId'
 *   },
 * });
 */
export function useGetHandoutsCourseNotesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHandoutsCourseNotesQuery,
        GetHandoutsCourseNotesQueryVariables
    > &
        ({ variables: GetHandoutsCourseNotesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHandoutsCourseNotesQuery, GetHandoutsCourseNotesQueryVariables>(
        Operations.GetHandoutsCourseNotes,
        options
    );
}
export function useGetHandoutsCourseNotesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHandoutsCourseNotesQuery,
        GetHandoutsCourseNotesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHandoutsCourseNotesQuery, GetHandoutsCourseNotesQueryVariables>(
        Operations.GetHandoutsCourseNotes,
        options
    );
}
export function useGetHandoutsCourseNotesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHandoutsCourseNotesQuery,
              GetHandoutsCourseNotesQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetHandoutsCourseNotesQuery,
        GetHandoutsCourseNotesQueryVariables
    >(Operations.GetHandoutsCourseNotes, options);
}
export type GetHandoutsCourseNotesQueryHookResult = ReturnType<
    typeof useGetHandoutsCourseNotesQuery
>;
export type GetHandoutsCourseNotesLazyQueryHookResult = ReturnType<
    typeof useGetHandoutsCourseNotesLazyQuery
>;
export type GetHandoutsCourseNotesSuspenseQueryHookResult = ReturnType<
    typeof useGetHandoutsCourseNotesSuspenseQuery
>;
export type GetHandoutsCourseNotesQueryResult = Apollo.QueryResult<
    GetHandoutsCourseNotesQuery,
    GetHandoutsCourseNotesQueryVariables
>;

/**
 * __useGetHandoutsFiltersAggregationsQuery__
 *
 * To run a query within a React component, call `useGetHandoutsFiltersAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandoutsFiltersAggregationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandoutsFiltersAggregationsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetHandoutsFiltersAggregationsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetHandoutsFiltersAggregationsQuery,
        GetHandoutsFiltersAggregationsQueryVariables
    > &
        (
            | { variables: GetHandoutsFiltersAggregationsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetHandoutsFiltersAggregationsQuery,
        GetHandoutsFiltersAggregationsQueryVariables
    >(Operations.GetHandoutsFiltersAggregations, options);
}
export function useGetHandoutsFiltersAggregationsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetHandoutsFiltersAggregationsQuery,
        GetHandoutsFiltersAggregationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetHandoutsFiltersAggregationsQuery,
        GetHandoutsFiltersAggregationsQueryVariables
    >(Operations.GetHandoutsFiltersAggregations, options);
}
export function useGetHandoutsFiltersAggregationsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetHandoutsFiltersAggregationsQuery,
              GetHandoutsFiltersAggregationsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetHandoutsFiltersAggregationsQuery,
        GetHandoutsFiltersAggregationsQueryVariables
    >(Operations.GetHandoutsFiltersAggregations, options);
}
export type GetHandoutsFiltersAggregationsQueryHookResult = ReturnType<
    typeof useGetHandoutsFiltersAggregationsQuery
>;
export type GetHandoutsFiltersAggregationsLazyQueryHookResult = ReturnType<
    typeof useGetHandoutsFiltersAggregationsLazyQuery
>;
export type GetHandoutsFiltersAggregationsSuspenseQueryHookResult = ReturnType<
    typeof useGetHandoutsFiltersAggregationsSuspenseQuery
>;
export type GetHandoutsFiltersAggregationsQueryResult = Apollo.QueryResult<
    GetHandoutsFiltersAggregationsQuery,
    GetHandoutsFiltersAggregationsQueryVariables
>;

/**
 * __useGetTrendsByTopicQuery__
 *
 * To run a query within a React component, call `useGetTrendsByTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendsByTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendsByTopicQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetTrendsByTopicQuery(
    baseOptions: Apollo.QueryHookOptions<GetTrendsByTopicQuery, GetTrendsByTopicQueryVariables> &
        ({ variables: GetTrendsByTopicQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetTrendsByTopicQuery, GetTrendsByTopicQueryVariables>(
        Operations.GetTrendsByTopic,
        options
    );
}
export function useGetTrendsByTopicLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetTrendsByTopicQuery, GetTrendsByTopicQueryVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetTrendsByTopicQuery, GetTrendsByTopicQueryVariables>(
        Operations.GetTrendsByTopic,
        options
    );
}
export function useGetTrendsByTopicSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<GetTrendsByTopicQuery, GetTrendsByTopicQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetTrendsByTopicQuery, GetTrendsByTopicQueryVariables>(
        Operations.GetTrendsByTopic,
        options
    );
}
export type GetTrendsByTopicQueryHookResult = ReturnType<typeof useGetTrendsByTopicQuery>;
export type GetTrendsByTopicLazyQueryHookResult = ReturnType<typeof useGetTrendsByTopicLazyQuery>;
export type GetTrendsByTopicSuspenseQueryHookResult = ReturnType<
    typeof useGetTrendsByTopicSuspenseQuery
>;
export type GetTrendsByTopicQueryResult = Apollo.QueryResult<
    GetTrendsByTopicQuery,
    GetTrendsByTopicQueryVariables
>;

/**
 * __usePartnerForFiltersQuery__
 *
 * To run a query within a React component, call `usePartnerForFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerForFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerForFiltersQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function usePartnerForFiltersQuery(
    baseOptions: Apollo.QueryHookOptions<PartnerForFiltersQuery, PartnerForFiltersQueryVariables> &
        ({ variables: PartnerForFiltersQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<PartnerForFiltersQuery, PartnerForFiltersQueryVariables>(
        Operations.PartnerForFilters,
        options
    );
}
export function usePartnerForFiltersLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PartnerForFiltersQuery,
        PartnerForFiltersQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<PartnerForFiltersQuery, PartnerForFiltersQueryVariables>(
        Operations.PartnerForFilters,
        options
    );
}
export function usePartnerForFiltersSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<PartnerForFiltersQuery, PartnerForFiltersQueryVariables>
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<PartnerForFiltersQuery, PartnerForFiltersQueryVariables>(
        Operations.PartnerForFilters,
        options
    );
}
export type PartnerForFiltersQueryHookResult = ReturnType<typeof usePartnerForFiltersQuery>;
export type PartnerForFiltersLazyQueryHookResult = ReturnType<typeof usePartnerForFiltersLazyQuery>;
export type PartnerForFiltersSuspenseQueryHookResult = ReturnType<
    typeof usePartnerForFiltersSuspenseQuery
>;
export type PartnerForFiltersQueryResult = Apollo.QueryResult<
    PartnerForFiltersQuery,
    PartnerForFiltersQueryVariables
>;

/**
 * __useGetPartnersTopicAggregationsQuery__
 *
 * To run a query within a React component, call `useGetPartnersTopicAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnersTopicAggregationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnersTopicAggregationsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetPartnersTopicAggregationsQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPartnersTopicAggregationsQuery,
        GetPartnersTopicAggregationsQueryVariables
    > &
        (
            | { variables: GetPartnersTopicAggregationsQueryVariables; skip?: boolean }
            | { skip: boolean }
        )
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        GetPartnersTopicAggregationsQuery,
        GetPartnersTopicAggregationsQueryVariables
    >(Operations.GetPartnersTopicAggregations, options);
}
export function useGetPartnersTopicAggregationsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPartnersTopicAggregationsQuery,
        GetPartnersTopicAggregationsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        GetPartnersTopicAggregationsQuery,
        GetPartnersTopicAggregationsQueryVariables
    >(Operations.GetPartnersTopicAggregations, options);
}
export function useGetPartnersTopicAggregationsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPartnersTopicAggregationsQuery,
              GetPartnersTopicAggregationsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPartnersTopicAggregationsQuery,
        GetPartnersTopicAggregationsQueryVariables
    >(Operations.GetPartnersTopicAggregations, options);
}
export type GetPartnersTopicAggregationsQueryHookResult = ReturnType<
    typeof useGetPartnersTopicAggregationsQuery
>;
export type GetPartnersTopicAggregationsLazyQueryHookResult = ReturnType<
    typeof useGetPartnersTopicAggregationsLazyQuery
>;
export type GetPartnersTopicAggregationsSuspenseQueryHookResult = ReturnType<
    typeof useGetPartnersTopicAggregationsSuspenseQuery
>;
export type GetPartnersTopicAggregationsQueryResult = Apollo.QueryResult<
    GetPartnersTopicAggregationsQuery,
    GetPartnersTopicAggregationsQueryVariables
>;

/**
 * __useSupportedAcademicEmailDomainsQuery__
 *
 * To run a query within a React component, call `useSupportedAcademicEmailDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedAcademicEmailDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedAcademicEmailDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedAcademicEmailDomainsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        SupportedAcademicEmailDomainsQuery,
        SupportedAcademicEmailDomainsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        SupportedAcademicEmailDomainsQuery,
        SupportedAcademicEmailDomainsQueryVariables
    >(Operations.SupportedAcademicEmailDomains, options);
}
export function useSupportedAcademicEmailDomainsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        SupportedAcademicEmailDomainsQuery,
        SupportedAcademicEmailDomainsQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        SupportedAcademicEmailDomainsQuery,
        SupportedAcademicEmailDomainsQueryVariables
    >(Operations.SupportedAcademicEmailDomains, options);
}
export function useSupportedAcademicEmailDomainsSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              SupportedAcademicEmailDomainsQuery,
              SupportedAcademicEmailDomainsQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        SupportedAcademicEmailDomainsQuery,
        SupportedAcademicEmailDomainsQueryVariables
    >(Operations.SupportedAcademicEmailDomains, options);
}
export type SupportedAcademicEmailDomainsQueryHookResult = ReturnType<
    typeof useSupportedAcademicEmailDomainsQuery
>;
export type SupportedAcademicEmailDomainsLazyQueryHookResult = ReturnType<
    typeof useSupportedAcademicEmailDomainsLazyQuery
>;
export type SupportedAcademicEmailDomainsSuspenseQueryHookResult = ReturnType<
    typeof useSupportedAcademicEmailDomainsSuspenseQuery
>;
export type SupportedAcademicEmailDomainsQueryResult = Apollo.QueryResult<
    SupportedAcademicEmailDomainsQuery,
    SupportedAcademicEmailDomainsQueryVariables
>;

/**
 * __useGetPjTrainingCoursesQuery__
 *
 * To run a query within a React component, call `useGetPjTrainingCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPjTrainingCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPjTrainingCoursesQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetPjTrainingCoursesQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPjTrainingCoursesQuery,
        GetPjTrainingCoursesQueryVariables
    > &
        ({ variables: GetPjTrainingCoursesQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetPjTrainingCoursesQuery, GetPjTrainingCoursesQueryVariables>(
        Operations.GetPjTrainingCourses,
        options
    );
}
export function useGetPjTrainingCoursesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPjTrainingCoursesQuery,
        GetPjTrainingCoursesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetPjTrainingCoursesQuery, GetPjTrainingCoursesQueryVariables>(
        Operations.GetPjTrainingCourses,
        options
    );
}
export function useGetPjTrainingCoursesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPjTrainingCoursesQuery,
              GetPjTrainingCoursesQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<GetPjTrainingCoursesQuery, GetPjTrainingCoursesQueryVariables>(
        Operations.GetPjTrainingCourses,
        options
    );
}
export type GetPjTrainingCoursesQueryHookResult = ReturnType<typeof useGetPjTrainingCoursesQuery>;
export type GetPjTrainingCoursesLazyQueryHookResult = ReturnType<
    typeof useGetPjTrainingCoursesLazyQuery
>;
export type GetPjTrainingCoursesSuspenseQueryHookResult = ReturnType<
    typeof useGetPjTrainingCoursesSuspenseQuery
>;
export type GetPjTrainingCoursesQueryResult = Apollo.QueryResult<
    GetPjTrainingCoursesQuery,
    GetPjTrainingCoursesQueryVariables
>;

/**
 * __useGetPartnerTenantVideosQuery__
 *
 * To run a query within a React component, call `useGetPartnerTenantVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerTenantVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerTenantVideosQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *   },
 * });
 */
export function useGetPartnerTenantVideosQuery(
    baseOptions: Apollo.QueryHookOptions<
        GetPartnerTenantVideosQuery,
        GetPartnerTenantVideosQueryVariables
    > &
        ({ variables: GetPartnerTenantVideosQueryVariables; skip?: boolean } | { skip: boolean })
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetPartnerTenantVideosQuery, GetPartnerTenantVideosQueryVariables>(
        Operations.GetPartnerTenantVideos,
        options
    );
}
export function useGetPartnerTenantVideosLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetPartnerTenantVideosQuery,
        GetPartnerTenantVideosQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetPartnerTenantVideosQuery, GetPartnerTenantVideosQueryVariables>(
        Operations.GetPartnerTenantVideos,
        options
    );
}
export function useGetPartnerTenantVideosSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetPartnerTenantVideosQuery,
              GetPartnerTenantVideosQueryVariables
          >
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetPartnerTenantVideosQuery,
        GetPartnerTenantVideosQueryVariables
    >(Operations.GetPartnerTenantVideos, options);
}
export type GetPartnerTenantVideosQueryHookResult = ReturnType<
    typeof useGetPartnerTenantVideosQuery
>;
export type GetPartnerTenantVideosLazyQueryHookResult = ReturnType<
    typeof useGetPartnerTenantVideosLazyQuery
>;
export type GetPartnerTenantVideosSuspenseQueryHookResult = ReturnType<
    typeof useGetPartnerTenantVideosSuspenseQuery
>;
export type GetPartnerTenantVideosQueryResult = Apollo.QueryResult<
    GetPartnerTenantVideosQuery,
    GetPartnerTenantVideosQueryVariables
>;
